/*
  mq.js — DAS eine Skript des Shops.

  Vorgabe vom 27.07.2026: eine CSS-Datei und eine JS-Datei.
  Am 29.07.2026 zusammengelegt. Vorher lud layout/theme.liquid fuenf Dateien;
  jetzt ist es diese eine. Die Reihenfolge unten ist GENAU die Ladereihenfolge
  von vorher — daran haengt Verhalten:
  section-snap baut die Ueberlagerung, scroll-shrink liest deren Scrollstand.

  Inhalt, in dieser Reihenfolge:
    1. Sendungsverfolgung und Ruecksendung  (sections/main-tracking.liquid)
    2. Sprachwahl                            (locale-picker)
    3. Ueberlagerung der Startseite          (section-snap)
    4. Schrumpfen beim Scrollen              (scroll-shrink)
    5. Warenkorb                             (cart)

  Jeder Teil ist wie vorher in sich gekapselt; nur cart legt absichtlich
  window.overlayAuf / window.overlayZu an — das ist DIE Auf/Zu-Funktion fuer
  alle Ueberlagerungen und wird von anderen Stellen aufgerufen.
  Von den alten Einzeldateien wurde vor der Zusammenlegung am 29.07.2026
  eine Sicherung ausserhalb des Themes abgelegt.
*/

/* ============================================================
   1 · Sendungsverfolgung und Ruecksendung
   ============================================================ */

(function () {
  'use strict';

  var form = document.querySelector('[data-trk-form]');
  if (!form) return;

  var ausgabe = document.querySelector('[data-trk-out]');
  var knopf = form.querySelector('[data-trk-submit]');
  var knopfText = knopf ? knopf.textContent : '';

  var retBereich = document.querySelector('[data-trk-ret]');
  var retOeffnen = document.querySelector('[data-trk-ret-open]');
  var retForm = document.querySelector('[data-trk-ret-form]');
  var stoBereich = document.querySelector('[data-trk-cancel]');
  var stoOeffnen = document.querySelector('[data-trk-cancel-open]');
  var stoBox = document.querySelector('[data-trk-cancel-box]');
  var stoSenden = document.querySelector('[data-trk-cancel-send]');
  var rekBereich = document.querySelector('[data-trk-claim]');
  var rekOeffnen = document.querySelector('[data-trk-claim-open]');
  var rekForm = document.querySelector('[data-trk-claim-form]');
  // Rechte Haelfte, ergaenzt am 02.08.2026. Fehlt die Sektion im Theme-Editor,
  // bleiben beide null — dann faellt die Karte auf ihren alten Platz links
  // zurueck. Die Seite funktioniert in jedem Fall.
  var hilfeBox = document.querySelector('[data-trk-hilfe]');
  var uebersicht = document.querySelector('[data-trk-uebersicht]');
  var uebersichtInhalt = document.querySelector('[data-trk-uebersicht-inhalt]');
  // Merkt sich, zu welcher Bestellung die Ruecksendung gehoert. Der Kunde soll
  // Nummer und Namen nicht ein zweites Mal eintippen muessen.
  var gefundene = null;
  var letzterNachname = '';

  // Aller Text kommt aus der Sprachdatei, eingebettet von der Liquid-Datei.
  var T;
  try {
    T = JSON.parse(document.querySelector('[data-trk-texte]').textContent);
  } catch (e) {
    return;
  }

  // Liquid wandelt Zeichen wie ' schon in &#39; um. Wuerde ich diese Texte
  // spaeter noch einmal maskieren, stuende "You&#39;ve" auf der Seite. Also
  // einmal zurueckwandeln — die Texte stammen aus unserer eigenen Sprachdatei
  // und sind vertrauenswuerdig. Alles, was vom Server kommt, bleibt maskiert.
  (function zurueckwandeln(o) {
    var hilfe = document.createElement('textarea');
    Object.keys(o).forEach(function (k) {
      if (typeof o[k] === 'string') {
        hilfe.innerHTML = o[k];
        o[k] = hilfe.value;
      } else if (Array.isArray(o[k])) {
        o[k] = o[k].map(function (s) { hilfe.innerHTML = s; return hilfe.value; });
      }
    });
  })(T);

  function entschaerfen(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  /* Antwort des Servers lesen — 26.09.2026. "Nicht gefunden" kommt mit 200 und
     gefunden:false (app-tracking/edge-script.ts); alles ausser 2xx ist ein
     Fehler (400 fehlendes Feld, 404 falscher Pfad, 500 Serverfehler). Vorher
     las r.json() auch die Fehlerantwort, fand darin kein "gefunden", und der
     Kunde las "nicht gefunden" statt "etwas ist schiefgelaufen". */
  function lesen(r) {
    if (!r.ok) { throw new Error('HTTP ' + r.status); }
    return r.json();
  }

  function melden(text) {
    ausgabe.innerHTML = '<p class="trk__msg">' + entschaerfen(text) + '</p>';
    ausgabe.hidden = false;
    /* Zustand 2 und 3: rechts steht weiter die Hilfe. Wer sich vertippt hat,
       braucht sie jetzt sogar mehr als vorher — und eine halb gefuellte
       Bestellkarte neben einer Fehlermeldung waere schlicht falsch.

       02.08.2026: nur, solange keine Bestellung gefunden ist. melden() wird
       auch fuer Erfolgsmeldungen benutzt — "Ruecksendung angemeldet",
       "Storno angenommen". Ohne diese Bedingung verschwand die gefundene
       Bestellung genau in dem Moment, in dem der Kunde eine Ruecksendung
       abschickte. */
    if (!gefundene) {
      if (uebersicht) { uebersicht.hidden = true; }
      if (hilfeBox) { hilfeBox.hidden = false; }
    }
  }

  function zeichnen(d) {
    // Links die Statusleiste, rechts die Bestellung. Dieselbe Aufteilung wie im
    // Checkout: links wird gehandelt, rechts steht, worum es geht.
    var links = '<ol class="trk__steps">';
    for (var i = 0; i < T.stationen.length; i++) {
      links += '<li class="trk__step' + (i < d.station ? ' trk__step--done' : '') + '">' +
        entschaerfen(T.stationen[i]) + '</li>';
    }
    links += '</ol>';

    var karte = '<div class="trk__card">';
    karte += '<div class="trk__row"><span class="trk__label">' + entschaerfen(T.bestellung) +
      '</span><span>#' + entschaerfen(d.nummer) + '</span></div>';

    if (d.sendungsnummer) {
      karte += '<div class="trk__row"><span class="trk__label">' + entschaerfen(T.sendungsnummer) +
        '</span><span>' + entschaerfen(d.sendungsnummer) +
        (d.versanddienst ? ' · ' + entschaerfen(d.versanddienst) : '') + '</span></div>';
    }

    if (d.artikel && d.artikel.length) {
      karte += '<ul class="trk__items">';
      for (var j = 0; j < d.artikel.length; j++) {
        karte += '<li><span>' + entschaerfen(d.artikel[j].titel) +
          '</span><span>&times;&nbsp;' + entschaerfen(d.artikel[j].menge) + '</span></li>';
      }
      karte += '</ul>';
    }

    // Nur Adressen zulassen, die auch wirklich Adressen sind — der Wert kommt
    // zwar aus unserer Datenbank, aber urspruenglich von Shopify.
    if (d.sendungslink && /^https:\/\//.test(d.sendungslink)) {
      karte += '<a class="trk__link" href="' + entschaerfen(d.sendungslink) +
        '" rel="noopener noreferrer" target="_blank">' + entschaerfen(T.sendung_verfolgen) + '</a>';
    }

    karte += '</div>';

    /*
      Was ist mit meiner Rueckgabe? — 03.08.2026 ergaenzt.

      Vorher sah der Kunde nach dem Absenden genau eine Bestaetigung und
      danach nie wieder etwas. Wer nicht weiss, wo sein Paket und sein Geld
      bleiben, schreibt eine Mail — oder holt sich das Geld ueber die Bank
      zurueck. Jetzt steht der Stand hier, bei jedem Aufruf.
    */
    if (d.vorgaenge && d.vorgaenge.length) {
      karte += '<div class="trk__card trk__vorgaenge">';
      karte += '<div class="trk__row"><span class="trk__label">' +
        entschaerfen(T.ret_stand_titel || 'Deine Anfrage') + '</span></div>';

      for (var v = 0; v < d.vorgaenge.length; v++) {
        var g = d.vorgaenge[v];
        var artText = T['art_' + g.art] || g.art;
        var standText = T['stand_' + g.status] || g.status;

        karte += '<div class="trk__vorgang">';
        karte += '<div class="trk__row"><span>' + entschaerfen(artText) +
          '</span><span class="trk__stand">' + entschaerfen(standText) + '</span></div>';

        if (g.angelegt_am) {
          karte += '<p class="trk__klein">' + entschaerfen(T.ret_beantragt_am || 'Beantragt am') +
            ' ' + entschaerfen(String(g.angelegt_am).slice(0, 10)) + '</p>';
        }
        if (g.retoure_nummer) {
          karte += '<p class="trk__klein">' +
            entschaerfen(T.ret_sendungsnummer || 'Sendungsnummer der Rücksendung') + ': ' +
            entschaerfen(g.retoure_nummer) +
            (g.retoure_dienst ? ' · ' + entschaerfen(g.retoure_dienst) : '') + '</p>';
        }
        if (g.erstattet_betrag) {
          karte += '<p class="trk__klein trk__gut">' +
            entschaerfen(T.ret_erstattet || 'Geld zurückgezahlt') + ': ' +
            entschaerfen(g.erstattet_betrag) +
            (g.erstattet_am ? ' · ' + entschaerfen(String(g.erstattet_am).slice(0, 10)) : '') +
            '</p>';
        }
        karte += '</div>';
      }

      // Die Ruecksendegebuehr steht getrennt: Sie entscheidet, ob es
      // ueberhaupt weitergeht, und ist der haeufigste Grund fuer Rueckfragen.
      if (d.gebuehr_faellig) {
        karte += '<p class="trk__klein' + (d.gebuehr_bezahlt ? ' trk__gut' : '') + '">' +
          entschaerfen(d.gebuehr_bezahlt
            ? (T.ret_gebuehr_bezahlt || 'Rücksendegebühr ist bezahlt.')
            : (T.ret_gebuehr_offen || 'Die Rücksendegebühr ist noch offen.')) + '</p>';
      }

      karte += '</div>';
    }

    /* Reicht die Sektion im DOM? Nein — sie kann da sein und trotzdem
       unsichtbar. Der Checkout blendet die rechte Spalte unter 1000 px per
       display:none aus. Die Bestellkarte landete dann in einem unsichtbaren
       Kasten, und wer am Handy sucht, saehe nur die Statusleiste ohne einen
       einzigen Bestelldatensatz.

       Geprueft wird die SEKTION um den Kasten herum, nicht der Kasten selbst:
       der traegt bis zum Fund sein eigenes hidden und haette immer
       offsetParent null.

       Die Breitenabfrage kam am 02.08.2026 dazu. Unter 1000 px ist die rechte
       Spalte zwar sichtbar, steht aber gestapelt unter der linken — und damit
       hinter der Fusszeile. Die Bestellung dort abzulegen hiesse, sie hinter
       allen Rechtslinks zu verstecken, waehrend oben nur die Statusleiste
       stehenbliebe. Auf schmalen Schirmen gehoert sie deshalb nach links,
       direkt unter die Statusleiste. 1000 px ist derselbe Umbruchpunkt wie in
       assets/base.css. */
    var huelle = uebersicht ? uebersicht.parentElement : null;
    var rechtsSichtbar = !!(
      uebersichtInhalt && huelle && huelle.offsetParent !== null &&
      window.matchMedia('(min-width: 1000px)').matches
    );

    if (rechtsSichtbar) {
      // Zustand 4: die Hilfe hat ihren Zweck erfuellt und macht Platz.
      ausgabe.innerHTML = links;
      uebersichtInhalt.innerHTML = karte;
      uebersicht.hidden = false;
      if (hilfeBox) { hilfeBox.hidden = true; }
    } else {
      // Rueckfall: schmaler Schirm oder Sektion nicht eingebaut. Dann steht
      // alles links, genau wie vor dem 02.08.2026.
      ausgabe.innerHTML = links + karte;
      if (uebersicht) { uebersicht.hidden = true; }
    }
    ausgabe.hidden = false;

    // Erst wenn eine Bestellung gefunden ist, gibt es etwas zurueckzusenden.
    if (retBereich) {
      retBereich.hidden = false;
      gefundene = { nummer: d.nummer, nachname: letzterNachname };
    }

    // Stornieren geht nur, solange nichts unterwegs ist. Sobald Shopify einen
    // anderen Versandstatus als "unfulfilled" meldet oder ein Zustellstatus
    // da ist, ist die Ruecksendung der richtige Weg. Der Server prueft das
    // noch einmal selbst — hier blenden wir den Knopf nur aus, damit niemand
    // einen Weg angeboten bekommt, der ohnehin abgelehnt wird.
    if (stoBereich) {
      var nochNichtUnterwegs = d.versandstatus === 'unfulfilled' && !d.zustellstatus;
      stoBereich.hidden = !nochNichtUnterwegs;
      if (stoBox) { stoBox.hidden = true; }
    }

    // Einen Mangel kann man erst melden, wenn die Ware unterwegs oder da ist.
    // Vorher gibt es nichts zu beanstanden — dann ist Stornieren der Weg.
    if (rekBereich) {
      rekBereich.hidden = d.versandstatus === 'unfulfilled' && !d.zustellstatus;
      if (rekForm) { rekForm.hidden = true; }
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var nummer = (form.querySelector('#trk-nummer').value || '').trim();
    var nachname = (form.querySelector('#trk-nachname').value || '').trim();

    if (!nummer || !nachname) {
      melden(T.leer);
      return;
    }

    letzterNachname = nachname;
    if (retBereich) { retBereich.hidden = true; }
    if (retForm) { retForm.hidden = true; }
    // Nach einer angemeldeten Ruecksendung versteckt der Erfolgspfad weiter
    // unten den Oeffnen-Knopf selbst. Ohne diese Zeile bliebe er fuer immer weg:
    // wer danach eine zweite Bestellung sucht, saehe einen wieder sichtbaren,
    // aber voellig leeren Ruecksendekasten ohne Weg hinein — nur ein Neuladen
    // half. Storno und Reklamation brauchen das nicht, dort wird nie der Knopf
    // versteckt, sondern der ganze Bereich, und der wird bei jedem Lauf gesetzt.
    if (retOeffnen) { retOeffnen.hidden = false; }
    if (stoBereich) { stoBereich.hidden = true; }
    if (stoBox) { stoBox.hidden = true; }
    if (rekBereich) { rekBereich.hidden = true; }
    if (rekForm) { rekForm.hidden = true; }
    gefundene = null;

    /* 26.09.2026: Der Server nimmt die letzte Zahlengruppe der Eingabe
       (nummerNormalisieren in app-tracking/edge-script.ts). Endet sie nicht auf
       Ziffern ("MQ1001A", "#"), antwortet er mit 400 — seit lesen() den Status
       prueft, stand dann "etwas ist schiefgelaufen" da, obwohl ein zweiter
       Versuch nichts aendert. Hier dieselbe Pruefung vorab, mit derselben
       Meldung wie vorher. */
    if (!/\d\s*$/.test(nummer)) {
      melden(T.nicht_gefunden);
      return;
    }

    melden(T.suche);
    if (knopf) { knopf.setAttribute('disabled', ''); }

    var adresse = T.endpunkt + '?nummer=' + encodeURIComponent(nummer) +
      '&nachname=' + encodeURIComponent(nachname);

    fetch(adresse, { headers: { 'Accept': 'application/json' } })
      .then(lesen)
      .then(function (d) {
        if (d && d.gefunden) { zeichnen(d); } else { melden(T.nicht_gefunden); }
      })
      .catch(function () { melden(T.fehler); })
      .then(function () {
        if (knopf) { knopf.removeAttribute('disabled'); knopf.textContent = knopfText; }
      });
  });

  // ---------------------------------------------------------- Ruecksendung

  if (retOeffnen && retForm) {
    retOeffnen.addEventListener('click', function () {
      retForm.hidden = !retForm.hidden;
    });
  }

  // ---------------------------------------------------------- Stornierung
  //
  // Ergaenzt am 01.08.2026. Der Kunde konnte eine Bestellung vorher nur per
  // Mail stornieren; im Shop gab es keinen Weg. Zwei Klicks: aufklappen,
  // bestaetigen. Ohne Grundauswahl — wer vor dem Versand widerruft, muss
  // sich nicht erklaeren.

  if (stoOeffnen && stoBox) {
    stoOeffnen.addEventListener('click', function () {
      stoBox.hidden = !stoBox.hidden;
    });
  }

  if (stoSenden) {
    stoSenden.addEventListener('click', function () {
      if (!gefundene) { return; }
      stoSenden.setAttribute('disabled', '');

      fetch(T.endpunkt_storno, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          nummer: gefundene.nummer,
          nachname: gefundene.nachname,
          grund: 'customer'
        })
      })
        .then(lesen)
        .then(function (d) {
          if (!d || !d.gefunden) { melden(T.nicht_gefunden); return; }
          if (d.moeglich === false) { melden(T.sto_zu_spaet); return; }
          melden(d.bereits_angemeldet ? T.sto_schon : T.sto_ok);
          if (stoBereich) { stoBereich.hidden = true; }
        })
        .catch(function () { melden(T.fehler); })
        .then(function () { stoSenden.removeAttribute('disabled'); });
    });
  }

  // ---------------------------------------------------------- Reklamation
  //
  // Defekt, beschaedigt oder falsch geliefert. Immer kostenlos, deshalb ohne
  // jede Gebuehrenfrage. Fotos sind freiwillig; sie gehen ueber Shopifys
  // eigenen Upload, wir schicken nur die Adressen mit.

  if (rekOeffnen && rekForm) {
    rekOeffnen.addEventListener('click', function () {
      rekForm.hidden = !rekForm.hidden;
    });
  }

  if (rekForm) {
    rekForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!gefundene) { return; }

      var art = rekForm.querySelector('#trk-art').value;
      var beschreibung = rekForm.querySelector('#trk-beschreibung').value;

      if (!art || !beschreibung.trim()) { melden(T.rek_fehlt); return; }

      var senden = rekForm.querySelector('[data-trk-claim-send]');
      if (senden) { senden.setAttribute('disabled', ''); }

      fetch(T.endpunkt_reklamation, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          nummer: gefundene.nummer,
          nachname: gefundene.nachname,
          art: art,
          beschreibung: beschreibung,
          bilder: []
        })
      })
        .then(lesen)
        .then(function (d) {
          if (!d || !d.gefunden) { melden(T.nicht_gefunden); return; }
          melden(d.bereits_angemeldet ? T.rek_schon : T.rek_ok);
          if (rekForm) { rekForm.hidden = true; }
        })
        .catch(function () { melden(T.fehler); })
        .then(function () { if (senden) { senden.removeAttribute('disabled'); } });
    });
  }

  // ---------------------------------------------------------- Ruecksendung

  if (retForm) {
    retForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!gefundene) { return; }

      var grund = retForm.querySelector('#trk-grund').value;
      var nachricht = retForm.querySelector('#trk-nachricht').value;

      if (!grund) { melden(T.ret_grund_fehlt); return; }

      var senden = retForm.querySelector('[data-trk-ret-send]');
      if (senden) { senden.setAttribute('disabled', ''); }

      fetch(T.endpunkt_ruecksendung, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          nummer: gefundene.nummer,
          nachname: gefundene.nachname,
          grund: grund,
          nachricht: nachricht
        })
      })
        .then(lesen)
        .then(function (d) {
          if (d && d.gefunden) {
            var text = d.bereits_angemeldet ? T.ret_schon : T.ret_ok;

            // Die Gebuehr. Der Server entscheidet: mit Gewaehrleistung oder bei
            // einem Mangel ist die Ruecksendung kostenlos, sonst 59 $ — und
            // dann erst zahlen, dann Ruecksendeschein. Der Knopf fuehrt auf
            // einen Warenkorb-Direktlink, also in den normalen Checkout.
            if (d.gebuehr_faellig && !d.gebuehr_bezahlt && T.gebuehr_link) {
              text = (T.ret_gebuehr || '').replace('{preis}', T.gebuehr_preis || '');
              ausgabe.innerHTML =
                '<p class="trk__msg">' + entschaerfen(text) + '</p>' +
                '<a class="cd__checkout trk__pay" href="' + entschaerfen(T.gebuehr_link) + '">' +
                entschaerfen((T.ret_gebuehr_knopf || '').replace('{preis}', T.gebuehr_preis || '')) +
                '</a>';
              ausgabe.hidden = false;
            } else if (!d.gebuehr_faellig) {
              melden(T.ret_frei || text);
            } else {
              melden(text);
            }

            retForm.hidden = true;
            if (retOeffnen) { retOeffnen.hidden = true; }
          } else {
            melden(T.fehler);
          }
        })
        .catch(function () { melden(T.fehler); })
        .then(function () { if (senden) { senden.removeAttribute('disabled'); } });
    });
  }
})();

/* ============================================================
   2 · Sprachwahl
   ============================================================ */

/* Land/Sprache-Fenster.

   Sprachen pro Land: Shopify kennt nur die Sprachen des gerade gewaehlten
   Marktes und sagt nichts darueber, welche Sprache in welchem Land gesprochen
   wird. Deshalb steht die Zuordnung hier — pro Land nur die Sprachen, die dort
   Amts- bzw. Verkehrssprache sind, aus unseren vier (en, es, pt-BR, fr).
   Ein Land, das hier nicht steht, zeigt alle vorhandenen Sprachen.

   Englisch steht ueberall dabei. Damit hat jedes Land mindestens zwei Sprachen —
   ausser den vier, in denen Englisch selbst die Landessprache ist: Bahamas,
   Barbados, Jamaika, Trinidad und Tobago. Dort bleibt es bei einer.
*/
(function () {
  var SPRACHEN_PRO_LAND = {
    BS: ['en'],              // Bahamas — Landessprache Englisch
    BB: ['en'],              // Barbados — Landessprache Englisch
    BO: ['es', 'en'],        // Bolivien
    BR: ['pt-BR', 'en'],     // Brasilien
    CA: ['en', 'fr'],        // Kanada
    CL: ['es', 'en'],        // Chile
    CO: ['es', 'en'],        // Kolumbien
    CR: ['es', 'en'],        // Costa Rica
    DO: ['es', 'en'],        // Dominikanische Republik
    EC: ['es', 'en'],        // Ecuador
    SV: ['es', 'en'],        // El Salvador
    HN: ['es', 'en'],        // Honduras
    JM: ['en'],              // Jamaika — Landessprache Englisch
    MX: ['es', 'en'],        // Mexiko
    PA: ['es', 'en'],        // Panama
    PY: ['es', 'en'],        // Paraguay
    PE: ['es', 'en'],        // Peru
    TT: ['en'],              // Trinidad und Tobago — Landessprache Englisch
    US: ['en', 'es'],        // USA
    UY: ['es', 'en']         // Uruguay
  };

  /* Die sechs Beschriftungen des Fensters in allen vier Sprachen.
     Sie stehen hier und nicht in den Sprachdateien, weil Shopify einer Seite
     immer nur die Texte der AKTUELLEN Sprache gibt — das Fenster soll aber
     schon beim Auswaehlen wechseln, vor dem Bestaetigen. */
  /* `cancel` ist am 10.08.2026 entfallen. Der Schluessel stammte aus der Zeit
     des Overlays, das einen grauen Weiter-einkaufen-Knopf hatte; die Seite hat
     keinen — in sections/main-language.liquid gibt es kein Element dafuer.
     Die vier verbliebenen Schluessel haben dort seit demselben Tag ihre
     data-t-Marken. */
  var TEXTE = {
    en: { title: 'Change country/region and language', country: 'Country/region', language: 'Language', confirm: 'Confirm' },
    es: { title: 'Cambiar país/región e idioma', country: 'País/región', language: 'Idioma', confirm: 'Confirmar' },
    'pt-BR': { title: 'Alterar país/região e idioma', country: 'País/região', language: 'Idioma', confirm: 'Confirmar' },
    fr: { title: 'Changer de pays/région et de langue', country: 'Pays/région', language: 'Langue', confirm: 'Confirmer' }
  };

  /* Seit 31.07.2026 gibt es die Auswahl als eigene SEITE (/pages/language,
     sections/main-language.liquid) statt als Overlay — so beauftragt. Die
     Mechanik darunter ist dieselbe geblieben, nur die Huelle faellt weg.

     10.08.2026: Der Rueckfall auf [data-locale-dialog] ist entfallen, ebenso
     die Weiche istSeite. Weder data-locale-dialog noch data-locale-open oder
     data-locale-close stehen noch in einer Markup-Datei des Themes — es gibt
     nur die Seite. */
  var dialog = document.querySelector('[data-locale-page]');
  if (!dialog) return;

  var felder = [].slice.call(dialog.querySelectorAll('[data-lf]'));
  var land = dialog.querySelector('[data-lf-kind="country"]');
  var sprache = dialog.querySelector('[data-lf-kind="language"]');

  function listeZu(feld) {
    feld.querySelector('[data-lf-list]').setAttribute('hidden', '');
    feld.querySelector('[data-lf-trigger]').setAttribute('aria-expanded', 'false');
  }

  function alleZu() {
    felder.forEach(listeZu);
  }

  function waehlen(feld, opt) {
    var trigger = feld.querySelector('[data-lf-trigger]');
    var input = feld.querySelector('[data-lf-input]');

    /* 26.09.2026: Hier wurde aria-selected an allen Zeilen gesetzt. Die Listen
       sind seitdem keine Listbox mehr (sections/main-language.liquid), und die
       gewaehlte Zeile ist ohnehin ausgeblendet. */

    input.value = opt.getAttribute('value');
    trigger.querySelector('.lf__name').textContent = opt.querySelector('.lf__name').textContent.trim();

    var f = trigger.querySelector('.lf__flag');
    var of = opt.querySelector('.lf__flag');
    if (f && of) f.src = of.getAttribute('src');

    var m = trigger.querySelector('.lf__meta');
    var om = opt.querySelector('.lf__meta');
    if (m && om) m.textContent = om.textContent.trim();

    listeZu(feld);
    listenAktualisieren();
    beschriftungenSetzen();
  }

  /* Beschriftungen auf die gerade gewaehlte Sprache umstellen — sofort,
     nicht erst nach dem Bestaetigen. */
  function beschriftungenSetzen() {
    if (!sprache) return;
    var texte = TEXTE[sprache.querySelector('[data-lf-input]').value];
    if (!texte) return;
    dialog.querySelectorAll('[data-t]').forEach(function (el) {
      var t = texte[el.getAttribute('data-t')];
      if (t) el.textContent = t;
    });
  }

  /* Zwei Regeln zugleich:
     1. Was schon oben im Feld steht, gehoert nicht noch einmal in die Liste.
     2. Sprachen, die im gewaehlten Land nicht vorkommen, fallen weg. */
  function listenAktualisieren() {
    var landCode = land ? land.querySelector('[data-lf-input]').value : null;
    var erlaubt = landCode ? SPRACHEN_PRO_LAND[landCode] : null;

    felder.forEach(function (feld) {
      var gewaehlt = feld.querySelector('[data-lf-input]').value;
      var istSprache = feld === sprache;
      var offen = 0;

      feld.querySelectorAll('[data-lf-opt]').forEach(function (o) {
        var wert = o.getAttribute('value');
        var passt = !istSprache || !erlaubt || erlaubt.indexOf(wert) > -1;
        var weg = !passt || wert === gewaehlt;
        o.parentElement.hidden = weg;
        if (!weg) offen++;
      });

      // Bleibt nichts uebrig, gibt es nichts aufzuklappen.
      var trigger = feld.querySelector('[data-lf-trigger]');
      if (offen === 0) {
        trigger.setAttribute('disabled', '');
        listeZu(feld);
      } else {
        trigger.removeAttribute('disabled');
      }
    });
  }

  /* Die Sprache folgt dem Land: gewaehlt wird die erste aus der Liste des Landes
     — das ist die Landessprache, Englisch steht dahinter. `immer` schaltet auch
     dann um, wenn die bisherige Sprache im neuen Land zwar erlaubt waere. */
  function sprachePruefen(immer) {
    if (!land || !sprache) return;
    var erlaubt = SPRACHEN_PRO_LAND[land.querySelector('[data-lf-input]').value];
    if (!erlaubt) return;
    var gewaehlt = sprache.querySelector('[data-lf-input]').value;
    if (!immer && erlaubt.indexOf(gewaehlt) > -1) return;
    if (erlaubt[0] === gewaehlt) return;

    var ziel = null;
    sprache.querySelectorAll('[data-lf-opt]').forEach(function (o) {
      if (!ziel && o.getAttribute('value') === erlaubt[0]) ziel = o;
    });
    if (ziel) waehlen(sprache, ziel);
  }

  document.addEventListener('click', function (e) {
    /* 10.08.2026 entfernt: die Zweige fuer [data-locale-open] und
       [data-locale-close]. Auf der Seite gibt es nichts zu oeffnen und nichts
       zu schliessen — die Auswahl steht einfach da. Beide Attribute stehen in
       keiner Markup-Datei des Themes mehr. */

    var trigger = e.target.closest('[data-lf-trigger]');
    if (trigger) {
      e.preventDefault();
      var feld = trigger.closest('[data-lf]');
      var liste = feld.querySelector('[data-lf-list]');
      var offen = !liste.hasAttribute('hidden');
      alleZu();
      if (!offen) {
        liste.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var opt = e.target.closest('[data-lf-opt]');
    if (opt) {
      e.preventDefault();
      var f = opt.closest('[data-lf]');
      /* Vor waehlen() merken: danach ist der Knopf versteckt. */
      var hatteFokus = document.activeElement === opt;
      waehlen(f, opt);
      if (f === land) sprachePruefen(true);
      /* Die Liste ist zu, der gedrueckte Knopf damit versteckt — der Fokus
         fiel auf <body>. Zurueck an den Ausloeser, wie beim Aufklapp-Muster
         vorgesehen (26.09.2026). Nur hier und nicht in waehlen(): Das laeuft
         auch, wenn die Sprache dem Land folgt, ohne dass jemand geklickt hat.
         Und nur, wenn der Knopf den Fokus hatte — Safari und Firefox auf dem
         Mac fokussieren beim Mausklick nicht, ein gesetzter Fokus koennte dort
         einen Rahmen zeigen. */
      var zurueck = f.querySelector('[data-lf-trigger]');
      if (hatteFokus && zurueck && !zurueck.disabled) { zurueck.focus({ preventScroll: true }); }
      return;
    }

    if (!e.target.closest('[data-lf]')) alleZu();
  });

  /* Escape schliesst die offene Liste.

     10.08.2026 korrigiert: Die erste Bedingung verlangte zusaetzlich die Klasse
     is-open am Dialog. Die stammt aus der Zeit, als die Auswahl ein Overlay war
     — die Seite traegt sie nie. Escape tat damit ueberhaupt nichts, obwohl das
     Zuklappen per Tastatur der einzige Weg ohne Maus ist. Der overlayZu-Zweig
     ist entfallen: Es gibt kein Overlay mehr, das sich schliessen liesse. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var offen = dialog.querySelector('[data-lf-list]:not([hidden])');
    if (!offen) return;
    /* 26.09.2026: Stand der Fokus in der Liste, geht er an deren Ausloeser
       zurueck — vorher fiel er mit der versteckten Liste auf <body>. */
    var feld = offen.closest('[data-lf]');
    var warDrin = feld && feld.contains(document.activeElement);
    alleZu();
    if (warDrin) { feld.querySelector('[data-lf-trigger]').focus({ preventScroll: true }); }
  });

  sprachePruefen();
  listenAktualisieren();
  beschriftungenSetzen();
})();

/* ============================================================
   3 · Ueberlagerung der Startseite
   ============================================================ */

(function () {
  // 750px ist die dritte Geraeteklasse des Checkouts. Bis zum 08.08.2026 stand
  // hier 48em, also 768px — dieselbe Absicht, aber ein eigener Wert, der zu
  // keiner der CSS-Grenzen passte.
  //
  // 10.08.2026 um (hover: hover) and (pointer: fine) ergaenzt. Die Ueberlagerung
  // laesst sich ausschliesslich per 'wheel' oeffnen (siehe unten) — ein Finger
  // loest das nie aus. Auf einem Tablet ab 750px wurde sie also gebaut, blieb
  // aber fuer immer zu, waehrend .scroll-stage per CSS fixed + overflow:hidden
  // war: alles unterhalb der Buehne unerreichbar. Touch-Geraete laufen jetzt im
  // normalen Fluss wie unter 750px. assets/base.css bindet die fixed-Regel an
  // dieselbe Bedingung; beide muessen zusammen bleiben.
  var abfrage = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  var stage = document.getElementById('scroll-stage');
  var hero = stage ? stage.querySelector('.hero') : null;
  if (!stage || !hero) return;

  // Ein Wechsel der Geraeteklasse — Fenster ueber die 750px ziehen, Maus
  // andocken — aenderte bis zum 10.08.2026 nur das CSS, nicht den DOM-Aufbau.
  // Wer unter 750px lud und dann aufzog, bekam fixed + overflow:hidden ohne
  // Ueberlagerung, also eine auf eine Bildschirmhoehe abgeschnittene Seite.
  //
  // Neu geladen wird nur, wenn CSS und DOM wirklich auseinanderlaufen, und nur
  // auf der Startseite: der Hero-Test steht bewusst davor, damit kein
  // Formular auf einer anderen Seite beim Fensterziehen seine Eingaben
  // verliert. Ein Tablet, das gedreht wird, loest nichts aus — hover und
  // pointer aendern sich dabei nicht.
  abfrage.addEventListener('change', function (e) {
    var gebaut = !!document.getElementById('scroll-stage__content');
    if (e.matches !== gebaut) location.reload();
  });

  if (!abfrage.matches) return;

  var heroWrapper = hero.closest('[id^="shopify-section-"]') || hero;

  var content = document.createElement('div');
  content.id = 'scroll-stage__content';
  content.className = 'scroll-stage__content';

  var node = heroWrapper.nextSibling;
  while (node) {
    var next = node.nextSibling;
    content.appendChild(node);
    node = next;
  }
  stage.appendChild(content);

  /*
    The overlay scrolls (overflow-y: auto) and the hero layer does not
    (.scroll-stage is overflow: hidden), so the overlay's content box is
    narrower than the hero's by exactly one scrollbar. Anything centred on
    one layer therefore lands half a scrollbar off from its counterpart on
    the other — visible as the logo jumping sideways on the hero/section-2
    switch.

    Measured off the real element rather than assumed: scrollbar width is a
    browser/OS thing (~15-17px on Windows, 0 with macOS overlay scrollbars),
    so hardcoding it would be wrong on most machines. The hero's bars use
    this to reserve the same gap — see sections/header.liquid and
    sections/top-bar.liquid.
  */
  function measureScrollbar() {
    var width = content.offsetWidth - content.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', width + 'px');
  }

  measureScrollbar();
  window.addEventListener('resize', measureScrollbar);

  /*
    The overlay's bars are transparent while parked over section 1's panel and
    go solid once anything scrolls underneath them. The docking itself needs no
    JS — position:sticky handles it (see sections/section2-top-bar.liquid and
    sections/section2-header.liquid) — this only reports whether the overlay
    has been scrolled at all.
  */
  function updateScrolled() {
    content.classList.toggle('is-scrolled', content.scrollTop > 0);
  }

  updateScrolled();
  content.addEventListener('scroll', updateScrolled, { passive: true });

  function aufmachen() {
    content.classList.add('is-visible');
  }

  function zumachen() {
    content.classList.remove('is-visible');
  }

  stage.addEventListener(
    'wheel',
    function (e) {
      if (e.deltaY > 0) {
        aufmachen();
      } else if (e.deltaY < 0 && content.scrollTop <= 0) {
        zumachen();
      }
    },
    { passive: true }
  );

  /*
    18.09.2026 — Die Ueberlagerung ging bis heute AUSSCHLIESSLICH per 'wheel' auf.
    Am laufenden Shop nachgestellt: PageDown, Leertaste, Pfeil-unten und End
    aenderten die Klassenliste nicht, ein Radereignis oeffnete sofort. Wer mit
    der Tastatur bedient, kam damit nie weiter als bis zum Hero — also nie zu
    Produktvorstellung, Merkmalen, den drei Story-Abschnitten, dem Markenbereich
    und dem Fuss mit den Rechtslinks.

    Die Bedingung (hover: hover) and (pointer: fine) oben schliesst den Finger
    aus, nicht die Tastatur: Wer eine Maus angeschlossen hat, hat meistens auch
    eine Tastatur. Das war ein Versehen, keine Entscheidung.

    Warum der Fokus mitwandert: .scroll-stage__content ist ein eigener
    Scrollbehaelter (overflow-y: auto). Ohne Fokus darin scrollt der Browser
    beim naechsten Tastendruck nichts — die Ueberlagerung waere offen, liesse
    sich aber nicht weiterbewegen. tabindex -1 macht ihn programmatisch
    fokussierbar, ohne ihn in die Tab-Reihenfolge zu haengen.

    Was ausdruecklich NICHT abgefangen wird: Tasten in einem Eingabefeld, in
    einem Auswahlfeld oder in bearbeitbarem Text, und Tasten mit Steuertaste
    oder Meta — das sind Browser-Kurzbefehle. Und nichts, solange ein Dialog
    offen ist.
  */
  content.tabIndex = -1;

  var AUF = { PageDown: 1, ArrowDown: 1, End: 1, ' ': 1, Spacebar: 1 };
  var ZU = { PageUp: 1, ArrowUp: 1, Home: 1 };

  document.addEventListener('keydown', function (e) {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (document.querySelector('.mq-ov.is-open')) return;

    var ziel = e.target;
    if (ziel && ziel.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')) return;

    if (AUF[e.key]) {
      if (content.classList.contains('is-visible')) return;
      e.preventDefault();
      aufmachen();
      content.focus({ preventScroll: true });
      if (e.key === 'End') content.scrollTop = content.scrollHeight;
      return;
    }

    if (ZU[e.key] && content.classList.contains('is-visible') && content.scrollTop <= 0) {
      e.preventDefault();
      zumachen();
      /* 26.09.2026: Der Fokus stand in der Ueberlagerung, die jetzt unter
         dem Fenster liegt — ein fokussiertes Element ausserhalb des Blicks
         (WCAG 2.4.11). Loesen statt versetzen: Der naechste Tab geht dort
         weiter, wo der Leser war, und oeffnet sie wieder (focusin unten). */
      if (content.contains(document.activeElement)) { document.activeElement.blur(); }
    }
  });

  /*
    26.09.2026 — Tab und Umschalt+Tab (WCAG 2.4.7 / 2.4.11). Die Tasten oben
    blaettern; von Element zu Element wandert man mit Tab, und das kannten sie
    nicht: Nach den Kopf-Symbolen sprang der Fokus in die geschlossene
    Ueberlagerung, auf Links unterhalb des Fensters. Jetzt oeffnet ein Fokus
    darin sie. Umgekehrt schliesst ein Fokus zurueck in der Buehne (Hero, Kopf)
    sie wieder — sonst laege der fokussierte Link unter der offenen
    Ueberlagerung.

    Nur bei TASTATURfokus (:focus-visible). Ein Mausklick fokussiert ebenfalls —
    die Ueberlagerung selbst hat tabindex -1 —, und der Browser meldet diesen
    Fokus erneut, wenn man aus einem anderen Tab oder Fenster zurueckkommt.
    Ohne die Einschraenkung fuhr die Ueberlagerung dann von selbst hoch oder
    runter, obwohl der Leser sie mit dem Rad woanders hingestellt hatte.
    Kennt ein Browser :focus-visible nicht, bleibt alles wie vorher.
  */
  stage.addEventListener('focusin', function (e) {
    var tastatur = false;
    try { tastatur = e.target.matches(':focus-visible'); } catch (fehler) { return; }
    if (!tastatur) return;
    var drin = content.contains(e.target);
    var offen = content.classList.contains('is-visible');
    if (drin && !offen) { aufmachen(); }
    else if (!drin && offen) { zumachen(); }
  });
})();

/* ============================================================
   4 · Schrumpfen beim Scrollen
   ============================================================ */

(function () {
  var section = document.querySelector('[data-scroll-shrink]');
  if (!section) return;

  var contents = section.querySelector('.feature-banner__contents');
  var textWrap = section.querySelector('.feature-banner__text-wrap');
  if (!contents) return;

  /*
    Transferred from samsung.com/us — ho-g-hero-kv-home's site.min.js. Their
    structure is kept as-is on purpose, because it is what makes the motion
    smooth: a self-looping requestAnimationFrame that runs every frame while
    scrolling, rather than work hung off the scroll event itself (which fires
    at its own irregular rate).

      handleScroll:      scrollTop = scrollY; start the loop if not running;
                         (re)arm a 100ms timer to detect scroll end
      scrollAnimateFunc: recalc offsetTop, updateShrinkMotion(), rAF(self)
      scrollEndFunc:     final updateShrinkMotion(), cancel the loop
      updateShrinkMotion: the maths, verbatim below

    MIN_HEIGHT_CAP is their 1080. Their 1440 width cap comes from
    --overlay-width here instead, since every section below this one lines up
    on that same width (assets/base.css) — one source, no drift.
  */
  var MIN_HEIGHT_CAP = 1080;
  var SCROLL_END_MS = 100;

  function widthCap() {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--overlay-width'));
    return isNaN(v) ? 1440 : v;
  }

  // On desktop/tablet the page itself doesn't scroll — this section sits in
  // the overlay, which is its own scroll container (assets/section-snap.js,
  // and the layer map in base.css). Below that breakpoint the document
  // scrolls normally again, so fall back to the window.
  function getScroller() {
    return document.getElementById('scroll-stage__content');
  }

  function readScrollTop() {
    var scroller = getScroller();
    return scroller ? scroller.scrollTop : window.scrollY;
  }

  var scrollStart = null;
  var scrollRequestFrame = null;
  var scrollEndTime = null;
  var scrollTop = 0;
  var offsetTop = 0;
  var maximumWidth = 0;
  var minimumWidth = 0;
  var maximumHeight = 0;
  var minimumHeight = 0;

  function setLayout() {
    contents.style.maxWidth = '';
    contents.style.height = '';

    var cap = widthCap();
    maximumWidth = section.clientWidth;
    minimumWidth = cap < maximumWidth ? cap : maximumWidth;

    maximumHeight = section.clientHeight;
    minimumHeight = MIN_HEIGHT_CAP < maximumHeight ? MIN_HEIGHT_CAP : maximumHeight;
  }

  // Verbatim from their d.prototype.updateShrinkMotion. overlapHeight is 0
  // here (that term is their sticky nav's height; we have no nav overlapping
  // this section), so `a` is just offsetTop.
  function updateShrinkMotion() {
    var a = offsetTop;
    var b = maximumHeight / 2;
    b = Math.min(scrollTop - a, b) / b;
    b = 0 > b ? 0 : b;

    if (0 < b && 1 > b && a + maximumHeight > scrollTop) {
      contents.classList.add('is-animation');
    } else {
      contents.classList.remove('is-animation');
    }

    var currentWidth = maximumWidth - (maximumWidth - minimumWidth) * b;
    var currentHeight = maximumHeight - (maximumHeight - minimumHeight) * b;
    if (currentWidth < minimumWidth) currentWidth = minimumWidth;
    if (currentHeight < minimumHeight) currentHeight = minimumHeight;

    contents.style.maxWidth = currentWidth + 'px';
    contents.style.height = currentHeight + 'px';
  }

  function scrollAnimateFunc() {
    var scroller = getScroller();
    offsetTop = scroller
      ? section.offsetTop
      : Math.round(section.getBoundingClientRect().top + scrollTop);
    updateShrinkMotion();
    scrollRequestFrame = requestAnimationFrame(scrollAnimateFunc);
  }

  function scrollEndFunc() {
    scrollStart = null;
    updateShrinkMotion();
    cancelAnimationFrame(scrollRequestFrame);
  }

  function handleScroll() {
    scrollTop = readScrollTop();
    if (scrollStart == null) {
      scrollStart = scrollTop;
      scrollAnimateFunc();
    }
    window.clearTimeout(scrollEndTime);
    scrollEndTime = window.setTimeout(scrollEndFunc, SCROLL_END_MS);
  }

  function handleResize() {
    setLayout();
    handleScroll();
  }

  /*
    Deliberate deviation: theirs reveals the text from the scroll handler
    (`0 < scrollTop && showContents()`), which works because their section is
    the top of a scrolling page. Ours sits in an overlay that opens AT
    scrollTop 0 — that condition would never be true and the text would never
    appear. An IntersectionObserver is the same intent: reveal once on screen.
  */
  /*
    Merkmalspruefung 'IntersectionObserver' in window samt else-Zweig.
    Am 06.08.2026 aus der Sicherung vom 02.08.2026 zurueckgeholt; sie ging beim
    Zuruecksetzen am 03./04.08.2026 verloren. Gebraucht wird sie, weil mq.js EINE
    Datei ist: kennt ein Browser die Schnittstelle nicht, wirft der ungeschuetzte
    Aufruf hier eine Ausnahme und ALLES Nachfolgende laeuft nie an — Modal-
    Steuerung und der komplette Warenkorb waeren tot. Gleiches Muster wie bei der
    Sprungnavigation weiter unten in dieser Datei.
  */
  if (textWrap && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            textWrap.classList.add('is-ani');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    ).observe(section);
  } else if (textWrap) {
    /* Alte oder eingeschraenkte Browser: Inhalt sichtbar lassen, statt die
       gesamte gemeinsame JS-Datei vor den Dialog-Funktionen abzubrechen. */
    textWrap.classList.add('is-ani');
  }

  setLayout();
  scrollTop = readScrollTop();
  updateShrinkMotion();

  (getScroller() || window).addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize);
})();

/* ============================================================
   5 · Warenkorb
   ============================================================ */

/*
  Functional cart: intercept the product form, add via /cart/add.js, re-render
  the cart-drawer section (Section Rendering API), slide the overlay drawer open.
  Checkout button links to Shopify's hosted /checkout. No design work here — the
  markup/section owns that. Progressive enhancement: if JS fails, the plain
  {% form 'product' %} still posts to /cart/add the normal way.
*/
/*
  VOLLSTAENDIGE MODAL-STEUERUNG.
  Am 06.08.2026 aus der Sicherung vom 02.08.2026 zurueckgeholt; sie ging beim
  Zuruecksetzen am 03./04.08.2026 verloren und war seither nur noch ein Rumpf aus
  zwei Klassen-Umschaltern. Gebraucht wird sie, weil das Markup weiterhin fuenf
  Fenster mit role="dialog" aria-modal="true" deklariert (layout/theme.liquid,
  snippets/info-dialog.liquid, snippets/plan-ask.liquid, sections/main-product.liquid).
  aria-modal="true" verspricht dem Screenreader Fokusfalle und gesperrten
  Hintergrund; der Rumpf hat dieses Versprechen nicht eingeloest.
*/
/*
  DIE eine Auf/Zu-Steuerung fuer alle Modals. Sie bildet nicht nur die Optik,
  sondern auch Shopifys Bedienmodell ab: Fokus auf die Beschriftung, Tab bleibt
  im Fenster, Escape schliesst, Fokus kehrt zum Ausloeser zurueck und die Seite
  dahinter ist waehrenddessen gesperrt.

  Seit dem 13.08.2026 ein STAPEL statt eines einzelnen Fensters.

  Vorher galt "genau ein offenes Fenster": Wurde eins geoeffnet, schloss die
  Steuerung das vorherige ersatzlos. Das ging so lange gut, wie kein Fenster aus
  einem anderen heraus aufging — im Warenkorb steht aber ein Fragezeichen, das
  die Versandbedingungen zeigt (snippets/cart-contents.liquid). Wer es drueckte,
  verlor den Warenkorb: Er wurde geschlossen, und nach dem Schliessen der Info
  gab es keinen Weg zurueck, weil der Warenkorb nur noch beim Hinzufuegen
  aufgeht. Der Kunde stand wieder auf der Produktseite.

  Jetzt liegen die Fenster uebereinander. Das oberste hat den Fokus und die
  Tab-Falle; wird es geschlossen, uebernimmt das darunterliegende. Der
  Hintergrund wird erst freigegeben, wenn der Stapel leer ist.
*/
(function () {
  var stapel = [];

  function oberstes() {
    return stapel.length ? stapel[stapel.length - 1] : null;
  }
  var gesperrt = false;
  var buehne = null;
  var buehneWarInert = false;
  var ausloeser = typeof WeakMap === 'function' ? new WeakMap() : null;
  var timer = typeof WeakMap === 'function' ? new WeakMap() : null;
  var fokusSelektor = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function ereignis(el, name) {
    el.dispatchEvent(new CustomEvent(name, { bubbles: false }));
  }

  function sichtbareFokusziele(el) {
    return Array.prototype.filter.call(el.querySelectorAll(fokusSelektor), function (ziel) {
      return !ziel.hasAttribute('hidden') && ziel.getClientRects().length > 0;
    });
  }

  function startFokus(el) {
    var panel = el.querySelector('[role="dialog"]') || el.querySelector('.mq-ov__card');
    if (!panel) return null;
    var id = panel.getAttribute('aria-labelledby');
    var titel = id ? document.getElementById(id) : null;
    return titel || panel.querySelector('[data-ov-initial-focus], .mq-ov__title, [data-ov-x]') || panel;
  }

  function fokussieren(ziel) {
    if (!ziel || !ziel.focus) return;
    try { ziel.focus({ preventScroll: true }); }
    catch (fehler) { ziel.focus(); }
  }

  /* Die Seite darf sich beim Oeffnen einer Ueberlagerung NICHT bewegen.

     Bis zum 11.08.2026 tat sie das: hintergrundSperren() setzte nur die Klasse
     mq-modal-open, und dazu gehoert in assets/base.css
     `html.mq-modal-open, html.mq-modal-open body { overflow: hidden }`. Nimmt
     man einem gescrollten Dokument den Ueberlauf, verliert es seine Scrollhoehe
     und der Browser setzt die Position auf 0 — die Seite sprang also jedes Mal
     an den Anfang, bevor der Warenkorb aufging. Sichtbar war das damals bei
     "View cart" und bei "Pre-Order Now", weil beide dieselbe Ueberlagerung
     oeffneten; "View cart" fuehrt seit dem 13.08.2026 auf die Warenkorb-Seite,
     der Sprung betraf aber jede Ueberlagerung.

     Jetzt wird die Position vorher gemerkt und der Koerper an genau dieser
     Stelle eingefroren; beim Schliessen springt sie zurueck. Fuer den Nutzer
     steht die Seite still. */
  var gemerkteHoehe = 0;

  function hintergrundSperren() {
    if (gesperrt) return;
    gesperrt = true;
    gemerkteHoehe = window.scrollY || document.documentElement.scrollTop || 0;

    /* Die Breite der Bildlaufleiste JETZT messen — mit der Klasse unten kommt
       `overflow: hidden`, und damit verschwindet die Rinne, die
       `scrollbar-gutter: stable` sonst dauerhaft freihaelt (assets/base.css).
       Das Fenster bleibt gleich breit, der Inhalt wird 15px schmaler: Der
       Schleier endete 15px vor dem rechten Rand, und dort schien das weisse
       Blatt durch. Der gemessene Wert dehnt die Ueberlagerung wieder auf die
       volle Fensterbreite. */
    var rinne = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--mq-rinne', rinne + 'px');
    document.documentElement.classList.add('mq-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -gemerkteHoehe + 'px';
    document.body.style.insetInline = '0';
    buehne = document.getElementById('scroll-stage');
    if (buehne) {
      buehneWarInert = buehne.hasAttribute('inert');
      buehne.inert = true;
    }
  }

  function hintergrundFreigeben() {
    if (!gesperrt) return;
    gesperrt = false;
    document.documentElement.classList.remove('mq-modal-open');
    document.documentElement.style.removeProperty('--mq-rinne');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.insetInline = '';
    /* Ohne 'instant' laeuft der Ruecksprung als weiche Bewegung, wenn im Theme
       scroll-behavior: smooth steht — der Nutzer saehe die Seite wandern. */
    window.scrollTo({ top: gemerkteHoehe, behavior: 'instant' });
    if (buehne && !buehneWarInert) buehne.inert = false;
    buehne = null;
  }

  function schliessen(el, fokusZurueck) {
    if (!el || (!el.classList.contains('is-open') && !el.classList.contains('is-closing'))) return;
    if (el.classList.contains('is-closing')) return;

    if (timer && timer.get(el)) window.clearTimeout(timer.get(el));
    el.classList.remove('is-open');
    el.classList.add('is-closing');

    var platz = stapel.indexOf(el);
    if (platz !== -1) stapel.splice(platz, 1);
    el.style.removeProperty('z-index');

    ereignis(el, 'mq:overlayclose');

    /* Liegt darunter noch ein Fenster, gehoert ihm ab sofort der Fokus — sonst
       stuende die Tab-Falle auf einem Fenster, das gerade verschwindet. */
    var darunter = oberstes();
    if (darunter) {
      window.requestAnimationFrame(function () {
        if (darunter.classList.contains('is-open')) fokussieren(startFokus(darunter));
      });
    }

    var dauer = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;
    var fertig = window.setTimeout(function () {
      el.classList.remove('is-closing');
      el.setAttribute('aria-hidden', 'true');

      if (!stapel.length && !document.querySelector('.mq-ov.is-open, .mq-ov.is-closing')) {
        hintergrundFreigeben();
      }

      /* Den Fokus nur dann an den Ausloeser zurueckgeben, wenn dahinter kein
         Fenster mehr steht. Sonst risse er ihn aus dem Fenster, das gerade
         wieder oben liegt. */
      if (fokusZurueck !== false && !stapel.length) {
        var zurueck = ausloeser ? ausloeser.get(el) : el.__mqAusloeser;
        if (zurueck && zurueck.isConnected) fokussieren(zurueck);
      }
    }, dauer);
    if (timer) timer.set(el, fertig);
  }

  window.overlayAuf = function (el) {
    if (!el) return;

    /* Schon im Stapel: nur nach oben holen, nicht doppelt eintragen. */
    var vorhandener = stapel.indexOf(el);
    if (vorhandener !== -1) stapel.splice(vorhandener, 1);

    var vorher = document.activeElement;
    if (ausloeser) ausloeser.set(el, vorher);
    else el.__mqAusloeser = vorher;

    if (timer && timer.get(el)) window.clearTimeout(timer.get(el));
    el.classList.remove('is-closing');
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    stapel.push(el);

    /* Alle Fenster teilen sich z-index: 1000 (assets/base.css). Bei gleichem
       Wert entscheidet die Reihenfolge im Markup, welches oben liegt — das waere
       Zufall. Die Stapelebene setzt den Wert deshalb ausdruecklich. */
    el.style.zIndex = String(1000 + stapel.length);

    hintergrundSperren();
    ereignis(el, 'mq:overlayopen');

    window.requestAnimationFrame(function () {
      fokussieren(startFokus(el));
    });
  };

  window.overlayZu = function (el) {
    schliessen(el, true);
  };

  document.addEventListener('keydown', function (e) {
    var aktuell = oberstes();
    if (!aktuell || !aktuell.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      ereignis(aktuell, 'mq:overlayescape');
      schliessen(aktuell, true);
      return;
    }

    if (e.key !== 'Tab') return;
    var ziele = sichtbareFokusziele(aktuell);
    if (!ziele.length) {
      e.preventDefault();
      fokussieren(startFokus(aktuell));
      return;
    }

    var erstes = ziele[0];
    var letztes = ziele[ziele.length - 1];
    var aktiver = document.activeElement;
    var aktivIstFokusziel = ziele.indexOf(aktiver) !== -1;
    if (e.shiftKey && (aktiver === erstes || !aktivIstFokusziel)) {
      e.preventDefault();
      fokussieren(letztes);
    } else if (!e.shiftKey && (aktiver === letztes || !aktivIstFokusziel)) {
      e.preventDefault();
      fokussieren(erstes);
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var aktuell = oberstes();
    if (aktuell && aktuell.classList.contains('is-open') && !aktuell.contains(e.target)) {
      fokussieren(startFokus(aktuell));
    }
  }, true);
})();

(function () {
  var SECTION = 'cart-drawer';
  // planAsk/planAskForm MUESSEN hier oben stehen, nicht unten bei ihren
  // Funktionen: ready() ruft seinen Block sofort auf, wenn die Seite schon
  // geladen ist. Eine Zeile "var planAsk = null" weiter unten laeuft DANACH und
  // haette das gerade gefundene Fenster wieder auf null gesetzt — genau daran
  // ist die Nachfrage beim ersten Versuch vorbeigelaufen (30.07.2026).
  var drawer, lastFocus, planAsk, planAskForm;

  // Der Anfang JEDER Adresse im Shop. In einer zweiten Sprache heisst er
  // "/es/", nicht "/". Wer hier "/" fest einbaut, wirft den spanischen Besucher
  // beim Warenkorb zurueck auf Englisch und auf die Standard-Waehrung.
  // Shopify stellt den Wert selbst bereit und er endet immer auf "/".
  // Quelle: shopify.dev/docs/storefronts/themes/markets/multiple-currencies-languages
  var WURZEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ============================================================
     26.09.2026 — DIE RESERVIERUNGSUHR IST ENTFERNT.

     Bis heute stand hier eine 15-Minuten-Frist: Ab dem ersten Artikel lief eine
     Uhr "Reserved for you · 14:59 left", danach wurde der Warenkorb ueber
     /cart/clear.js geleert. Der Code sagte selbst, dass nichts reserviert
     wurde ("eine FRIST, keine Reservierung des Lagerbestands") — der Bestand
     wird bei BuckyDrop gar nicht gezaehlt.

     Entfernt auf Patryks Entscheidung, aus zwei Gruenden:
     - WCAG 2.2.1 Timing Adjustable: Eine Frist, die der Inhalt setzt, muss
       abschaltbar oder verlaengerbar sein, mit Warnung vorher. Die Uhr hatte
       beides nicht, und auf der Produktseite war sie gar nicht zu sehen.
     - FTC, "Bringing Dark Patterns to Light" (14.09.2022): kuenstliche
       Dringlichkeit und Countdowns sind dort ausdruecklich als Dark Pattern
       beschrieben. Unser Markt sind die USA.

     Mit ihr gingen: die Anzeigezeile in snippets/cart-contents.liquid, ihr CSS
     in sections/cart-drawer.liquid (.cd__hold) und die Texte hold_label,
     hold_time, hold_expired in allen vier Sprachdateien. Alte Warenkoerbe
     tragen evtl. noch das versteckte Attribut _reserviert_bis; es erscheint
     weder in Bestellung noch Rechnung und wird von nichts mehr gelesen.
     Rueckweg: git-Tag vor-sicherheitsfixes-2026-09-26.
     ============================================================ */
  var RABATTVERSUCH = 'mq-rabatt-versuch';

  /*
    Die Fehlerzeile des Warenkorbs (snippets/cart-contents.liquid).

    Sie bedient zwei Wege, die bis zum 15.08.2026 still scheiterten: den
    Muelleimer und den Rabattcode. Aufbau wie kauffehler() beim Kaufknopf —
    ohne Text verschwindet sie, damit ein geglueckter zweiter Versuch die alte
    Meldung nicht stehen laesst.

    text      Shopifys eigener Grund, falls einer mitkam. Er ist bereits
              uebersetzt und genauer als jeder eigene Satz.
    istRabatt true nimmt den Ersatztext fuer Rabattcodes statt den fuer den
              Warenkorb — dieselbe Zeile, zwei Anlaesse.
  */
  function warenkorbfehler(text, istRabatt) {
    var zeilen = document.querySelectorAll('[data-cd-err]');
    if (!zeilen.length) return;
    zeilen.forEach(function (zeile) {
      if (!text && text !== null) { zeile.hidden = true; zeile.textContent = ''; return; }
      var ersatz = istRabatt
        ? zeile.getAttribute('data-fallback-discount')
        : zeile.getAttribute('data-fallback');
      var satz = text || ersatz || '';
      if (!satz) { zeile.hidden = true; zeile.textContent = ''; return; }
      zeile.textContent = satz;
      zeile.hidden = false;
    });
  }

  ready(function () {
    drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    merkeMindesthoehe();

    /* Beim Laden jeder Seite herstellen, was gelten soll. Das faengt alles ab,
       was neben dem Kaufknopf passiert: eine ueber /cart/change.js von Hand
       geloeschte Zugabe, ein zweiter Tab, ein alter Warenkorb aus der Zeit vor
       dem 16.09.2026. */
    zugabeSichern(function (abschnitte, geaendert) {
      if (geaendert) { neuZeichnen(abschnitte, null); }
    });

    planAsk = document.querySelector('[data-plan-ask]');
    /* Am 06.08.2026 aus der Sicherung vom 02.08.2026 zurueckgeholt. Der eigene
       Escape-Handler der Nachfrage ist entfallen, weil die Modal-Steuerung oben
       jetzt einen zentralen mitbringt. Sein Rest — das gemerkte Formular wieder
       vergessen — haengt darum hier am Schliess-Ereignis und greift dadurch bei
       JEDEM Weg zu: Kreuz, Blende, Escape. */
    if (planAsk) {
      planAsk.addEventListener('mq:overlayclose', function () {
        planAskForm = null;
      });
    }

    // Add to cart (any product form) → AJAX + open drawer.
    // Davor die Nachfrage nach dem Schutz, falls "Nein danke" gewaehlt ist.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      if (planAskNoetig()) { planAskAuf(form); return; }
      addToCart(form);
    });

    document.addEventListener('click', function (e) {
      /* Hier stand ein Zweig fuer [data-cart-open]. Das Attribut gibt es im
         Markup nicht mehr: Die Tasche im Kopf fuehrt seit dem 31.07.2026 per
         href auf die Warenkorb-Seite (snippets/nav-icons.liquid), "View cart"
         in der Kaufbox seit dem 13.08.2026 ebenso. Am 13.08.2026 live
         nachgezaehlt: null Treffer im Dokument. Der Zweig konnte also nie mehr
         wahr werden und pruefte trotzdem jeden Klick der Seite mit. */
      if (e.target.closest('[data-cd-close]')) { e.preventDefault(); closeDrawer(); return; }

      /* Das gemerkte Formular MUSS vor dem Schliessen gesichert werden.

         planAskZu() ruft schliessen(), und das feuert mq:overlayclose noch in
         derselben Zeile — der Zuhoerer weiter oben setzt planAskForm daraufhin
         auf null. Wer erst schliesst und dann `if (planAskForm)` prueft, prueft
         also immer null: Beide Wege aus der Nachfrage heraus legten NICHTS in
         den Warenkorb. Gemessen am 13.08.2026 auf /products/laser-mosquit —
         kein einziger Aufruf an /cart/add.js, Warenkorb blieb bei 0 Artikeln.
         Damit war der Kaufknopf tot, sobald die Nachfrage erschien.

         Das Vergessen am Schliess-Ereignis bleibt richtig: Es faengt Kreuz,
         Blende und Escape ab. Nur diese zwei Wege wollen das Formular behalten,
         also halten sie es selbst fest. */

      // Nachfrage-Fenster: Laufzeit gewaehlt → merken und weiter in den Warenkorb
      var pick = e.target.closest('[data-plan-pick]');
      if (pick) {
        e.preventDefault();
        var formularMitSchutz = planAskForm;

        /* Das Kaestchen der gewaehlten Laufzeit setzen. Es IST das Optionsfeld
           der Variante — das Ereignis loest den Abgleich in
           sections/main-product.liquid aus, der die andere Laufzeit abwaehlt
           und Preis, Verfuegbarkeit und Variantennummer nachzieht. Ohne das
           bliebe im Formular die alte Nummer stehen und der Kunde bekaeme das
           Geraet ohne den Schutz, den er gerade gewaehlt hat. */
        var box = document.getElementById(pick.getAttribute('data-plan-pick'));
        if (box) {
          box.checked = true;
          box.dispatchEvent(new Event('change', { bubbles: true }));
        }
        planAskZu();
        if (formularMitSchutz) addToCart(formularMitSchutz);
        return;
      }
      // "Nein danke" im Fenster → ohne Schutz weiter in den Warenkorb
      if (e.target.closest('[data-plan-ask-skip]')) {
        e.preventDefault();
        var formularOhneSchutz = planAskForm;
        planAskZu();
        if (formularOhneSchutz) addToCart(formularOhneSchutz);
        return;
      }
      // Kreuz oder Blende → nur zu, NICHTS in den Warenkorb
      if (e.target.closest('[data-plan-ask-close]')) {
        e.preventDefault();
        planAskZu();
        planAskForm = null;
        return;
      }

      var d = e.target.closest('[data-cd-disclosure]');
      if (d) { e.preventDefault(); toggleDisclosure(d); }
    });

    /* Hier stand ein eigener Escape-Handler fuer die Nachfrage. Am 06.08.2026
       entfernt, weil die aus der Sicherung vom 02.08.2026 zurueckgeholte
       Modal-Steuerung oben einen zentralen Escape-Handler mitbringt; zwei Wege
       gleichzeitig wuerden dasselbe Fenster doppelt schliessen. Das Vergessen
       des Formulars laeuft jetzt ueber mq:overlayclose weiter oben. */

    // Discount code — the checkout's field, wired to Shopify's own discount URL.
    // WURZEL, nicht "/": in einer zweiten Sprache liegt der Warenkorb unter
    // "/es/" und ein festes "/" wuerfe den Kunden zurueck auf Englisch.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cd-discount]');
      if (!form) return;
      e.preventDefault();
      var feld = form.querySelector('input[name="discount"]');
      var code = (feld.value || '').trim();
      /* Leeres Feld: bis zum 15.08.2026 passierte hier gar nichts — kein Hinweis,
         kein Fokus. Jetzt sagt die Zeile, was fehlt. */
      if (!code) { warenkorbfehler(null, true); if (feld.focus) feld.focus(); return; }
      /* Den Versuch merken. Shopifys Rabatt-Adresse leitet auf den Warenkorb
         zurueck, ob der Code galt oder nicht — nach dem Neuladen ist sonst nicht
         mehr feststellbar, dass ueberhaupt einer eingegeben wurde.
         sessionStorage, weil der Versuch zum Tab gehoert und nicht zum Geraet. */
      try { window.sessionStorage.setItem(RABATTVERSUCH, code); } catch (fehler) { /* privater Modus */ }
      window.location.href = WURZEL + 'discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    });

    /*
      Nach der Rueckkehr von Shopifys Rabatt-Adresse: Hat der Code gegriffen?

      Shopify sagt es nicht — es leitet in beiden Faellen wortlos auf den
      Warenkorb zurueck. Der Kunde sah bis zum 15.08.2026: Seite blinkt, Feld
      leer, Preis unveraendert, und wusste nicht, ob sein Code falsch war oder
      der Shop kaputt.

      Feststellen laesst es sich trotzdem: /cart.js fuehrt jeden Code mit einem
      Merkmal "applicable". Steht der gemerkte Code dort nicht oder nicht als
      anwendbar, hat er nicht gegriffen.
    */
    (function () {
      var versuch = null;
      try { versuch = window.sessionStorage.getItem(RABATTVERSUCH); } catch (fehler) { return; }
      if (!versuch) return;
      try { window.sessionStorage.removeItem(RABATTVERSUCH); } catch (fehler) { /* egal */ }

      fetch(WURZEL + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(jsonLesen)
        .then(function (cart) {
          var codes = (cart && cart.discount_codes) || [];
          var gegriffen = codes.some(function (c) {
            return c && c.applicable && String(c.code).toLowerCase() === versuch.toLowerCase();
          });
          if (!gegriffen) warenkorbfehler(null, true);
        })
        .catch(function () { /* Ohne Antwort lieber nichts behaupten. */ });
    })();

    rabattPlaketten();

    /*
      Das Fragezeichen in der Versandzeile. Im Checkout haengt daran React und
      oeffnet ein Fenster mit der vollstaendigen Versandrichtlinie — am
      31.07.2026 dort geoeffnet und gelesen. Hier dasselbe, mit demselben Text:
      der Rumpf wird aus /policies/shipping-policy geholt, nicht nachgeschrieben.
      Einmal geholt, dann gemerkt.
    */
    var infoText = {};

    /* Konnte der Text nicht geholt werden, sagt das Fenster genau das — und
       bietet die Seite selbst an. Vorher stand hier bei jedem Fehlschlag der
       Versand-Satz, auch wenn nach Rueckgabe oder Garantie gefragt war, und
       immer auf Englisch. Der Satz kommt jetzt aus dem Markup
       (snippets/info-dialog.liquid), weil diese Datei keine Uebersetzungen
       kennt. 15.08.2026. */
    function infoFehler(rumpf, url) {
      var satz = rumpf.getAttribute('data-info-error') || '';
      var verweis = document.createElement('a');
      verweis.href = url;
      verweis.textContent = url;
      var absatz = document.createElement('p');
      absatz.className = 'info-ov__laedt';
      absatz.textContent = satz ? satz + ' ' : '';
      absatz.appendChild(verweis);
      rumpf.textContent = '';
      rumpf.appendChild(absatz);
    }

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-cd-info]');
      if (!knopf) return;
      e.preventDefault();
      var fenster = document.querySelector('[data-info-dialog]');
      if (!fenster) return;
      var pfad = knopf.getAttribute('data-cd-info');
      var titel = fenster.querySelector('[data-info-title]');
      var rumpf = fenster.querySelector('[data-info-body]');
      if (titel) titel.textContent = knopf.getAttribute('data-cd-info-title') || '';
      window.overlayAuf(fenster);
      if (infoText[pfad]) { rumpf.innerHTML = infoText[pfad]; return; }
      rumpf.innerHTML = '<p class="info-ov__laedt">…</p>';
      /* Ein Pfad mit fuehrendem Schraegstrich wird unveraendert geholt, alles
         andere als Rechtstext behandelt. So kann derselbe Knopf sowohl
         /policies/shipping-policy als auch /pages/limited-warranty oeffnen.
         11.08.2026 ergaenzt fuer das Fragezeichen am Garantieblock. */
      var url = pfad.charAt(0) === '/'
        ? pfad.replace(/^\//, WURZEL)
        : WURZEL + 'policies/' + pfad;
      fetch(url)
        .then(textLesen)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var teil = doc.querySelector('.shopify-policy__body .rte') ||
                     doc.querySelector('.shopify-policy__body') ||
                     doc.querySelector('.pg__inner .rte') ||
                     doc.querySelector('.rte');
          if (!teil) { infoFehler(rumpf, url); return; }
          infoText[pfad] = teil.innerHTML;
          rumpf.innerHTML = infoText[pfad];
        })
        .catch(function () { infoFehler(rumpf, url); });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-info-close]')) return;
      var fenster = document.querySelector('[data-info-dialog]');
      if (fenster) window.overlayZu(fenster);
    });

    /* Hier stand ein eigener Escape-Handler fuer das Info-Fenster. Am 06.08.2026
       entfernt: die aus der Sicherung vom 02.08.2026 zurueckgeholte
       Modal-Steuerung oben schliesst per Escape zentral, ein zweiter Weg waere
       doppelt. */

    /*
      Das x an der Rabatt-Plakette. /cart/update.js mit leerem discount loescht
      den Code — am 31.07.2026 am laufenden Shop geprueft: davor
      discount_codes [Free First Shipping], danach [].
    */
    document.addEventListener('click', function (e) {
      var weg = e.target.closest('[data-cd-discount-remove]');
      if (!weg) return;
      e.preventDefault();
      if (weg.hasAttribute('disabled')) return;
      weg.setAttribute('disabled', '');
      fetch(WURZEL + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '', sections: sektionsListe(), sections_url: window.location.pathname })
      })
        /* 26.09.2026: Status pruefen wie beim Muelleimer. Vorher lief eine
           abgelehnte Antwort als Erfolg durch, zeichnete den unveraenderten Korb
           neu, und der Code blieb ohne ein Wort stehen. */
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw (res.d && res.d.description) || ''; }
          warenkorbfehler('');
          if (res.d.sections) { updateInner(res.d.sections); } else { refresh(); }
        })
        .catch(function (err) {
          warenkorbfehler(typeof err === 'string' && err ? err : null);
          console.warn('[cart] discount remove failed:', err);
          weg.removeAttribute('disabled');
        });
    });

    /*
      Muelleimer je Zeile. /cart/update.js statt /cart/change.js, weil eine
      Bundle-Zeile mitsamt ihrem Schutz in EINEM Aufruf verschwinden muss —
      zwei Aufrufe koennten halb scheitern und einen bezahlten Schutz ohne
      Geraet zuruecklassen. Menge 0 = entfernen.

      Antwort bringt den Abschnitt gleich mit, updateInner() ersetzt damit
      JEDEN Warenkorb-Koerper der Seite (Schieber UND rechte Spalte), sodass
      Schieber und Seite nie auseinanderlaufen.
    */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cd-remove]');
      if (!btn) return;
      e.preventDefault();
      if (btn.hasAttribute('disabled')) return;
      /* Wo der Knopf stand, fuer den Fokus danach (nachEntfernen). Den Fokus
         nur weitergeben, wenn der Knopf ihn hatte: Safari und Firefox auf dem
         Mac fokussieren einen Knopf beim Mausklick nicht, und ein Fokus, den
         das Skript danach setzt, koennte dort einen Rahmen zeigen. */
      var hatteFokus = document.activeElement === btn;
      var imSchieber = !!btn.closest('#cart-drawer');
      var flaeche = imSchieber ? drawer : document.querySelector('[data-cart-section]');
      var stelle = flaeche
        ? Array.prototype.indexOf.call(flaeche.querySelectorAll('[data-cd-remove]'), btn)
        : 0;
      btn.setAttribute('disabled', '');

      var updates = {};
      updates[btn.getAttribute('data-cd-key')] = 0;
      var zweit = btn.getAttribute('data-cd-key2');
      if (zweit) { updates[zweit] = 0; }

      fetch(WURZEL + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sektionsListe(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw (res.d && res.d.description) || ''; }
          warenkorbfehler('');
          /* War das der letzte Laser, geht die Zugabe mit. Sonst bliebe ein
             Geschenk ohne Kauf im Warenkorb stehen — und der Rabatt griffe
             nicht mehr, der Kunde saehe die Lampe ploetzlich fuer 179 $. */
          zugabeSichern(function (abschnitte) {
            neuZeichnen(abschnitte, res.d.sections).then(function () {
              nachEntfernen(imSchieber, Math.max(stelle, 0), hatteFokus);
            }).catch(function (err) {
              warenkorbfehler(null);
              console.warn('[cart] redraw after remove failed:', err);
            });
          });
        })
        .catch(function (err) {
          /* Bis zum 15.08.2026 blieb es hier bei console.warn: Der Kunde drueckte
             den Muelleimer, die Zeile blieb stehen, und nichts sagte ihm warum. */
          warenkorbfehler(typeof err === 'string' && err ? err : null);
          console.warn('[cart] remove failed:', err);
          btn.removeAttribute('disabled');
        });
    });

    /*
      Letzte Pruefung vor dem Checkout — 17.09.2026.

      Der Rabatt deckelt den Wert (eine Lampe gratis, jede weitere kostet
      179 $), aber die MENGE haelt nur zugabeSichern(). Bisher lief das beim
      Seitenaufruf, nach dem Kauf und nach dem Loeschen einer Zeile. Wer den
      Warenkorb ueber die Ajax-Schnittstelle veraendert und danach auf
      "Checkout" drueckt, ohne dass dazwischen eine Seite geladen wird, kam an
      allen drei Punkten vorbei. Dieser Zuhoerer schliesst genau diese Luecke.

      Der Knopf ist ein Link, kein Formular. Deshalb: Klick abfangen, aufraeumen,
      dann selbst zur Adresse gehen. Der Wecker ist die Notbremse — haengt der
      Aufruf, geht es nach 2,5 Sekunden trotzdem weiter. Ein Kunde darf nie am
      Kaufknopf stehenbleiben, nur weil eine Nebenpruefung klemmt.

      Bleibt offen: Wer die Checkout-Adresse direkt aufruft, laedt unsere Seite
      gar nicht. Serverseitig dicht bekaeme man das nur mit einer eigenen
      Shopify-Funktion, und die verlangt Shopify Plus.
    */
    var gehtZumCheckout = false;
    document.addEventListener('click', function (e) {
      /* NUR die beiden echten Warenkorb-Knoepfe — 17.09.2026 nachgeschaerft.

         Vorher stand hier `a.cd__checkout`, also die Klasse allein. Genau die
         baut aber auch die Sendungsverfolgung an ihren Knopf
         "Ruecksendegebuehr zahlen" (oben in dieser Datei, trk__pay). Der
         Schieber liegt auf jeder Seite, dieser Zuhoerer also auch: Ein Klick
         auf den Gebuehrenknopf verzoegerte die Navigation und legte dabei eine
         Gratislampe in den Warenkorb, die dann im Gebuehren-Checkout mitlief.
         Die Zugabe hat im Gebuehrenvorgang nichts verloren.

         Die beiden gemeinten Knoepfe stehen in snippets/cart-foot.liquid (im
         Schieber, also unter #cart-drawer) und in sections/cart-page.liquid
         (in .cart-cta). */
      var zum = e.target.closest('#cart-drawer a.cd__checkout, .cart-cta a.cd__checkout');
      if (!zum || gehtZumCheckout) return;
      e.preventDefault();
      /* Der Merker steht in der Funktion, nicht als Attribut am Element.
         Am Element blieb er nach dem ersten Klick fuer immer stehen: Wer ueber
         die Zuruecktaste zurueckkam, lief beim zweiten Klick in den frueheren
         Ausstieg — ohne preventDefault, also ungeprueft in den Checkout. Genau
         die Luecke, die dieser Zuhoerer schliessen soll. */
      gehtZumCheckout = true;
      var ziel = zum.href;
      var gegangen = false;
      var weiter = function () {
        /* Der Wecker und die Antwort koennen beide ankommen — der Wecker
           zuerst, die Antwort danach; clearTimeout kommt dann zu spaet. Eine
           zweite Zuweisung an location.href mitten in einer laufenden
           Navigation ist browserabhaengig, also genau einmal. */
        if (gegangen) return;
        gegangen = true;
        window.location.href = ziel;
      };
      var wecker = setTimeout(weiter, 2500);
      zugabeSichern(function () { clearTimeout(wecker); weiter(); });
    });

    /* Hier stand ein eigener Escape-Handler fuer den Warenkorb-Schieber. Am
       06.08.2026 entfernt: die aus der Sicherung vom 02.08.2026 zurueckgeholte
       Modal-Steuerung oben schliesst per Escape zentral und gibt dabei auch den
       Fokus an den Ausloeser zurueck. */
  });

  // The page keeps its scrollbar while the cart is open — no overflow:hidden, no
  // width compensation, nothing toggling. Less code, and nothing can shift.
  /*
    Mindesthoehe der ARTIKELLISTE = ihre Hoehe im aufgeklappten Zustand.

    Sie sitzt auf der Liste, nicht auf der Karte: Klappt man die Buendel zu,
    bleibt der freie Platz in der Liste stehen, statt dass Zwischensumme,
    Versand, Gesamt und die beiden Knoepfe nach oben rutschen. Der Wert wird bei
    jedem Neuaufbau frisch genommen, damit er zur Artikelzahl passt.
  */
  function merkeMindesthoehe() {
    var liste = drawer.querySelector('.cd__panel .x-summary ._1b9t7yp2');
    if (!liste) return;
    liste.style.minHeight = '';
    /*
      Nur auf breiten Schirmen. Am 08.08.2026 nachgerechnet: Auf einem Geraet
      mit 667px Hoehe bleiben nach der Kopfzeile rund 567px. Eine aufgeklappte
      Buendelliste braucht schon allein etwa 500px, dazu Summen und Fusszeile —
      zusammen mehr als die Karte hoch werden darf. Da die Karte overflow
      hidden traegt, wurde der Ueberhang abgeschnitten, und der Kasse-Knopf
      lag ausserhalb.

      Diese feste Mindesthoehe haette jedes Schrumpfen verhindert. Auf schmalen
      Schirmen darf die Liste stattdessen scrollen; den Deckel dafuer setzt das
      CSS in sections/cart-drawer.liquid.
    */
    if (!window.matchMedia('(min-width: 1000px)').matches) return;
    var h = liste.offsetHeight;
    if (h > 0) liste.style.minHeight = h + 'px';
  }

  function openDrawer() { window.overlayAuf(drawer); }
  function closeDrawer() { window.overlayZu(drawer); }

  /*
    Welche Abschnitte beim Aendern des Warenkorbs zurueckkommen sollen.

    Der Schieber und die Cart-Seite zeigen DIESELBE Vorlage, aber nicht
    dasselbe: der Schieber blendet das Rabattfeld aus. Wurde nur der Schieber
    angefordert und seine Fassung ueberall eingesetzt, verschwand auf der
    Cart-Seite nach dem Entfernen einer Zeile das Rabattfeld — am 31.07.2026
    im Browser beobachtet. Deshalb beide anfordern und jeder Flaeche ihre
    eigene Fassung zurueckgeben.
  */
  /*
    Angewendete Rabattcodes sichtbar machen.

    Liquid kennt sie nicht: cart.discount_codes gibt es nur in /cart.js, und ein
    Versandrabatt taucht im Warenkorb in keiner Rabattbuchung auf. Am 31.07.2026
    gemessen: /cart.js meldete "Free First Shipping", waehrend
    cart_level_discount_applications leer und total_discount 0 war. Deshalb wird
    die Plakette hier eingesetzt — aus der Vorlage im Warenkorb-Koerper, damit
    der Aufbau nur an EINER Stelle steht und 1:1 der des Checkouts bleibt.

    Laeuft nach jedem Neuzeichnen erneut, weil der Koerper dabei ersetzt wird.
  */
  function rabattPlaketten() {
    /* 10.08.2026: Suche ueber das Datenattribut statt ueber den aria-label.
       Der trug den englischen Text; in jeder anderen der vier Sprachen fand
       das Skript die Liste nicht und der eingeloeste Rabattcode blieb im
       Warenkorb unsichtbar. Siehe snippets/cart-contents.liquid. */
    var listen = document.querySelectorAll('ul[data-cd-discount-list]');
    if (!listen.length) return;
    fetch(WURZEL + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(jsonLesen)
      .then(function (c) {
        var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; });
        listen.forEach(function (ul) {
          ul.textContent = '';
          var vorlage = ul.parentElement.querySelector('template[data-cd-discount-pill]') ||
                        document.querySelector('template[data-cd-discount-pill]');
          if (!vorlage) return;
          // Das Wort fuer "entfernen" kommt aus der Vorlage, damit auch diese
          // Beschriftung in der Sprache des Kunden steht.
          var wegWort = vorlage.getAttribute('data-cd-remove-word') || 'Remove';
          codes.forEach(function (d) {
            var teil = vorlage.content.cloneNode(true);
            var gross = teil.querySelector('[data-cd-code-gross]');
            var klein = teil.querySelector('[data-cd-code]');
            var weg = teil.querySelector('[data-cd-discount-remove]');
            if (gross) gross.textContent = d.code.toUpperCase();
            if (klein) klein.textContent = d.code;
            if (weg) weg.setAttribute('aria-label', wegWort + ' ' + d.code);
            ul.appendChild(teil);
          });
        });
      })
      .catch(function (err) { console.warn('[cart] discount pills failed:', err); });
  }

  function sektionsListe() {
    var el = document.querySelector('[data-cart-section]');
    var id = el && el.getAttribute('data-cart-section');
    return id ? SECTION + ',' + id : SECTION;
  }

  function ersterKoerper(html) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector('.cd__inner');
  }

  function updateInner(sections) {
    /* Hier stand ein Rueckfall fuer einen alten Aufrufweg mit einem einzelnen
       HTML-Text. Alle vier Aufrufer uebergeben ein Objekt; der Zweig war seit
       dem Umbau auf die Section Rendering API nicht mehr erreichbar. */
    var seiteEl = document.querySelector('[data-cart-section]');
    var seiteId = seiteEl && seiteEl.getAttribute('data-cart-section');
    var drawerNeu = sections[SECTION] ? ersterKoerper(sections[SECTION]) : null;
    var seiteNeu = (seiteId && sections[seiteId]) ? ersterKoerper(sections[seiteId]) : null;
    var fresh = seiteNeu || drawerNeu;
    if (!fresh) return;
    var n = fresh.getAttribute('data-count') || '0';
    // Replace EVERY cart body on the page — the drawer AND the collection page's
    // right column — so all cart views stay in sync. cloneNode because one node
    // can only be inserted in one place.
    document.querySelectorAll('.cd__inner').forEach(function (cur) {
      var aufSeite = seiteEl && seiteEl.contains(cur);
      var ersatz = aufSeite ? (seiteNeu || drawerNeu) : (drawerNeu || seiteNeu);
      cur.replaceWith(ersatz.cloneNode(true));
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = (n === '0');
    });
    // Per-surface CTAs live OUTSIDE .cd__inner (drawer foot, /cart checkout), so
    // the re-render above doesn't touch them — toggle them by the count instead:
    // hide the checkout when the cart is empty, show the "keep shopping" link.
    var empty = (n === '0');
    document.querySelectorAll('[data-cart-empty-hide]').forEach(function (el) { el.hidden = empty; });
    document.querySelectorAll('[data-cart-when-empty]').forEach(function (el) { el.hidden = !empty; });
    // Der Koerper wurde gerade ersetzt — die Plaketten muessen neu hinein.
    rabattPlaketten();
    merkeMindesthoehe();
  }

  /*
    Nachfrage nach dem Schutz (snippets/plan-ask.liquid — seit 19.09.2026
    nicht mehr gerendert, seit 27.09.2026 geloescht; ohne das Fenster bleibt
    dieser Teil wirkungslos, siehe layout/theme.liquid). Steht auf der
    Produktseite "Nein danke", wird gefragt, BEVOR der Artikel in den Warenkorb
    geht. Die Laufzeit-Knoepfe werden hier aus der Auswahl auf der Seite
    uebernommen — dadurch stimmen Laufzeit, Preis, Waehrung und Sprache immer
    mit dem ueberein, was daneben steht, und die Liste gibt es nur einmal.
  */
  /*
    Die Schutzwahl besteht aus zwei Kaestchen im Kaufkasten — je eines pro
    Laufzeit. Vorher waren es Auswahlknoepfe samt einer stillen dritten Zeile
    fuer „kein Schutz"; beides ist entfallen, es gibt keine versteckte zweite
    Auswahl mehr.

    Wo sie stehen, hat sich am 05.09.2026 geaendert: Der nachgebaute
    Checkout-Kasten (.co-haken) wurde durch snippets/pyd-kaufkasten.liquid
    ersetzt. Dass diese beiden Funktionen weiter nach .co-haken suchten, ist
    niemandem aufgefallen, weil ein leeres Ergebnis hier wie „es gibt keine
    Schutzwahl" aussieht: Die Nachfrage vor dem Kauf ging seitdem still nie mehr
    auf. Am 17.09.2026 auf der Produktseite nachgezaehlt — .co-haken 0 Treffer,
    [data-plan-head] 0 Treffer, das Fenster selbst aber vorhanden.

    Gesucht wird jetzt im Garantiekasten (#warranty), und zwar an der Zeile:
    label.pyd-wahl mit einem Feld, das data-pb-opt traegt. Genau diese Felder
    sind die Optionsfelder der Variante. Die Einschraenkung auf #warranty ist
    noetig, weil die Deal-Auswahl darueber dasselbe Attribut benutzt — und weil
    die Klone im Nachfragefenster sonst mitgezaehlt wuerden.
  */
  function planZeilen() {
    return Array.prototype.filter.call(
      document.querySelectorAll('#warranty .pyd-wahl input[data-pb-opt]'),
      function (box) {
        var zeile = box.closest('.pyd-wahl');
        return zeile && !zeile.hidden && zeile.offsetParent !== null;
      }
    );
  }

  function planAskNoetig() {
    if (!planAsk) return false;
    var kopf = document.querySelector('[data-plan-head]');
    if (!kopf || kopf.hidden) return false;
    var boxen = planZeilen();
    if (!boxen.length) return false;
    /* Gefragt wird genau dann, wenn KEINE Laufzeit gewaehlt ist. */
    return !boxen.some(function (box) { return box.checked; });
  }

  /*
    Die Auswahl im Fenster ist eine KOPIE der Zeilen aus dem Kaufkasten —
    15.08.2026.

    Vorher baute diese Stelle eigene Knoepfe aus Text und Preis. Sie sahen den
    Zeilen daneben nur aehnlich; jede Aenderung an der Box musste hier
    nachgezogen werden. Jetzt werden die echten Zeilen geklont: gleiche
    Beschriftung, gleicher Preis, gleiches Kaestchen, gleicher Rahmen — ohne
    zweite Stelle zum Pflegen.

    Drei Dinge muss der Klon abgeben, sonst waere er ein zweites Original:
      · eine eigene Kennung, weil zwei gleiche id ungueltiges HTML sind und die
        Beschriftung sonst das falsche Kaestchen anspraeche
      · das Attribut data-pb-opt, sonst zaehlte planZeilen() die Klone mit und
        das Fenster fuellte sich bei jedem Oeffnen weiter auf
      · den Haken, denn im Fenster ist noch nichts gewaehlt

    data-plan-pick an der Zeile traegt die Kennung des ECHTEN Kaestchens. Ein
    Klick auf die Kopie setzt also das Original auf der Seite.
  */
  function planAskAuf(form) {
    var ziel = planAsk.querySelector('[data-plan-ask-opts]');
    ziel.textContent = '';
    /* Die Klone brauchen ihre Umgebung mit — 17.09.2026.

       assets/pyd.css beschreibt die Zeilen fast durchweg als NACHFAHREN des
       Kastens (.pyd .pyd-wahl, .pyd > div:has(label) …). Im Fenster hing der
       Klon frei im Dokument, keine dieser Regeln traf, und aus zwei Karten
       wurden zwei nackte Textfetzen nebeneinander. Deshalb wird hier dieselbe
       Schachtelung nachgebaut wie im Kaufkasten: der Kasten, darin die Zeile
       mit den Labels. Das ist keine Kopie von Gestaltung — es ist dieselbe. */
    var kasten = document.createElement('div');
    kasten.className = 'pyd';
    var reihe = document.createElement('div');
    kasten.appendChild(reihe);
    ziel.appendChild(kasten);
    planZeilen().forEach(function (box) {
      var zeile = box.closest('.pyd-wahl');
      if (!zeile) return;
      var klon = zeile.cloneNode(true);
      var klonBox = klon.querySelector('input[type="checkbox"]');
      if (klonBox) {
        /* Die Zeile IST das label und umschliesst ihr Kaestchen — ein
           for-Attribut gibt es nicht mehr und muss deshalb auch nicht
           nachgezogen werden. Die neue Kennung braucht es trotzdem: zwei
           gleiche id sind ungueltiges HTML. */
        klonBox.id = 'plan-ask-' + box.id;
        klonBox.checked = false;
        klonBox.removeAttribute('data-pb-opt');
      }
      /* Der Preis im Klon ist eine Momentaufnahme. Ohne das Attribut schreibt
         das Seitenskript beim naechsten Mengenwechsel nicht auch noch in die
         Kopie — es sucht seine Felder ueber genau diese Kennung. */
      var preis = klon.querySelector('[data-schutz-preis]');
      if (preis) { preis.removeAttribute('data-schutz-preis'); }
      klon.setAttribute('data-plan-pick', box.id);
      reihe.appendChild(klon);
    });
    planAskForm = form;
    window.overlayAuf(planAsk);
  }

  function planAskZu() {
    if (planAsk) window.overlayZu(planAsk);
  }

  /* Zeigt oder verbirgt die Fehlerzeile unter dem Kaufknopf. Ohne Text wird
     sie versteckt, damit ein geglueckter zweiter Versuch die alte Meldung
     nicht stehen laesst. */
  function kauffehler(text) {
    /* ALLE Zeilen, nicht nur die erste. Es gibt eine je Kaufknopf: eine im
       Formular und eine unter dem mitlaufenden Knopf. Welche davon im Blick ist,
       haengt an der Fensterbreite und an der Scrollposition der Kaufspalte —
       beschriftet werden deshalb beide. */
    var boxen = document.querySelectorAll('[data-pb-adderr]');
    if (!boxen.length) { return; }
    boxen.forEach(function (box) {
      if (!text) { box.hidden = true; box.textContent = ''; return; }
      box.textContent = text;
      box.hidden = false;
    });
  }

  /*
    Sperrt beide Kaufknoepfe fuer die Dauer des Aufrufs und gibt eine Funktion
    zurueck, die alles wieder herstellt.

    Zwei Dinge waren hier bis zum 13.08.2026 falsch:

    1. Nur der Knopf IM FORMULAR wurde gesperrt. Ab 1000px Breite ist aber
       .pb__stickyadd der sichtbare Knopf — er blieb waehrend des Aufrufs
       druckbar, ein zweiter Druck legte ein zweites Mal an.

    2. Der Ladetext wurde mit textContent gesetzt. Das loescht die Kinder des
       Knopfes: den <span data-pb-addtext> und darin die Auszeichnung aus
       snippets/knopftext.liquid. Zurueck kam reiner Text — aus "PRE" hochgestellt
       wurde "PREOrder Now" am Stueck. Schlimmer noch: sections/main-product.liquid
       merkt sich diesen Span in einer Variablen (dort addText), um bei jedem
       Variantenwechsel den Knopftext zu setzen. Nach dem ersten Kauf zeigte die
       Variable auf einen abgehaengten Knoten, und der Knopftext folgte der
       Variante nicht mehr.

    Deshalb wird jetzt nur der INHALT des Textknotens getauscht und danach als
    Auszeichnung zurueckgeschrieben. Der Knoten selbst bleibt derselbe.
  */
  function knoepfeSperren() {
    var gefunden = [];
    document.querySelectorAll('[data-pb-add], [data-pb-stickyadd]').forEach(function (knopf) {
      var ziel = knopf.querySelector('[data-pb-addtext]') || knopf;
      gefunden.push({ knopf: knopf, ziel: ziel, inhalt: ziel.innerHTML, warDeaktiviert: knopf.hasAttribute('disabled') });
    });

    /* Der Ladetext kommt aus dem Markup, weil | t in dieser Datei nicht laeuft.
       Fehlt das Attribut, bleibt der bisherige Text stehen — besser als ein
       englisches Wort in einem spanischen Shop. */
    /* data-pb-busy, 26.09.2026: die Marke "hier laeuft gerade ein Kauf".
       Die Variantenwahl der Produktseite (render in sections/main-product
       .liquid) setzt disabled und Knopftext bei JEDER Aenderung an Deal,
       Laufzeit oder Menge neu — auch mitten in einem laufenden Kauf. Damit hob
       sie die Sperre auf, und ein zweiter Klick legte ein zweites Geraet ein.
       Solange die Marke steht, laesst render() den Knopf in Ruhe. */
    gefunden.forEach(function (g) {
      var text = g.knopf.getAttribute('data-pb-adding');
      g.knopf.setAttribute('disabled', '');
      g.knopf.setAttribute('data-pb-busy', '');
      if (text) g.ziel.textContent = text;
    });

    return function freigeben() {
      gefunden.forEach(function (g) {
        g.knopf.removeAttribute('data-pb-busy');
        if (!g.warDeaktiviert) g.knopf.removeAttribute('disabled');
        g.ziel.innerHTML = g.inhalt;
      });
      /* Der Stand vom Klick kann inzwischen falsch sein: Wer waehrend des
         Kaufs auf eine ausverkaufte Variante gewechselt hat, bekaeme sonst
         wieder "Add to cart" statt "Sold out". Wer den Knopf aus der gewaehlten
         Variante ableitet, stellt ihn jetzt neu her. Hoert niemand zu (Seiten
         ohne Variantenwahl), bleibt der zurueckgeschriebene Stand. */
      document.dispatchEvent(new CustomEvent('mq:kauf-frei'));
    };
  }

  /*
    ---------- Die Gratis-Zugabe ----------

    Bis zum 16.09.2026 war die Lampe ein Bestandteil des Laser-Bundles. Ein
    Bestandteil vervielfacht sich zwingend mit der Menge: drei Bundles hiessen
    drei Lampen. Gewollt ist genau eine je Bestellung, und "nur einmal je
    Bestellung" gibt es bei Shopify-Bundles nicht.

    Seitdem ist die Lampe eine eigene Zeile: ein nicht gelistetes Produkt zu
    179,00 $, das ein automatischer BETRAGSRABATT von 179,00 $ auf null zieht —
    "Free Mosquit. Killer Lamp Pro", einmal je Bestellung. Ein Betragsrabatt hat
    keine Kaufseite und fasst die Laser-Zeile deshalb nicht an; der frueher hier
    benutzte "Kaufe X, erhalte Y" tat das und zerlegte sie dabei. Er heisst im
    Admin inzwischen "ALT Kaufe X erhalte Y" und ist abgeschaltet.

    Der Rabatt deckelt den WERT: Wer die Zugabe von Hand hochzaehlt, bekommt eine
    geschenkt und zahlt jede weitere. Die MENGE haelt nur diese Funktion.
    Hineingelegt wird die Lampe ohnehin nie von selbst — Shopify legt ein
    Geschenk grundsaetzlich nicht in den Warenkorb.

    Sie STELLT HER, was gelten soll, statt etwas zu addieren:
      Laser im Korb, genau eine Zugabe -> nichts tun
      Laser im Korb, sonst             -> alle Zugabe-Zeilen weg, eine neu
      kein Laser mehr im Korb          -> alle Zugabe-Zeilen weg
    Dadurch ist sie beliebig oft aufrufbar; der zweite Aufruf hintereinander
    aendert nichts mehr und schickt auch nichts.

    Warum "alle Zeilen" und nicht "die eine": Es kann mehr als eine geben. Zwei
    Wege dorthin sind belegt. Erstens teilte der alte "Kaufe X, erhalte Y" eine
    Zugabe-Zeile, deren Menge ueber die eine kostenlose hinausging — am
    16.09.2026 gemessen: Zugabe von Hand auf 3 gesetzt, danach 2 x 179,00 $ und
    1 x kostenlos in getrennten Zeilen. Der heutige Betragsrabatt teilt nicht
    mehr (am 17.09.2026 gegengemessen). Zweitens koennen zwei Aufrufe dieser
    Funktion sich ueberholen — der beim Seitenstart und einer vom Muelleimer —
    und beide eine Zugabe anlegen. Wer nur die letzte Zeile anschaut, findet
    dort Menge 1, haelt alles fuer richtig und laesst die bezahlten stehen.

    Die Zeile traegt die Eigenschaft _zugabe. Der Unterstrich haelt sie aus
    Warenkorb, Checkout und Bestellung heraus; snippets/cart-contents.liquid
    erkennt die Zeile daran und laesst den Muelleimer weg. Die Zugabe gehoert
    nicht dem Kunden zum Wegwerfen — sie gehoert zum Angebot.

    Die beiden Nummern kommen aus snippets/zugabe-daten.liquid. Fehlen sie,
    passiert hier nichts.
  */
  /* Der Erfolg wird geprueft, nicht angenommen — 17.09.2026.

     Bis dahin endete die Kette bei r.json(). Eine 422-Antwort von cart/add.js
     ist aber gueltiges JSON und lief glatt durch: Scheiterte das Aufraeumen in
     zugabeSichern(), legte der naechste Schritt trotzdem eine weitere Lampe
     nach — und erzeugte genau den Zustand, den das Aufraeumen beseitigen
     sollte. addToCart und der Muelleimer pruefen res.ok seit jeher; hier fehlte
     es. Geworfen wird Shopifys eigener Grund, weil der bereits uebersetzt ist. */
  /* Antwort nur lesen, wenn sie ein Erfolg ist — 26.09.2026. Ein Fehler
     (Drosselung 429, Serverfehler 5xx) kam bisher als "leerer Korb" an:
     /cart.js ohne items, ohne discount_codes. Die Rabatt-Plaketten wurden
     dann geloescht und ein gerade eingeloester Code als "hat nicht
     gegriffen" gemeldet. Jetzt landet er im Fehlerzweig des Aufrufers. */
  function jsonLesen(r) {
    if (!r.ok) { throw new Error('HTTP ' + r.status); }
    return r.json();
  }
  function textLesen(r) {
    if (!r.ok) { throw new Error('HTTP ' + r.status); }
    return r.text();
  }

  function korbSchicken(pfad, koerper) {
    koerper.sections = sektionsListe();
    koerper.sections_url = window.location.pathname;
    return fetch(WURZEL + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(koerper)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { throw (d && d.description) || new Error(pfad + ' ' + r.status); }
        return d;
      });
    });
  }

  function zugabeSichern(fertig) {
    var Z = window.MQ_ZUGABE;
    if (!Z || !Z.variante || !Z.ausloeser) {
      /* Nicht stillschweigend aussteigen — 17.09.2026. Fehlen die Nummern,
         wird nicht nur nichts hineingelegt: Eine bereits vorhandene
         Zugabe-Zeile wird dann auch nie wieder ENTFERNT, auch nicht, wenn der
         letzte Laser aus dem Korb fliegt. Der Kunde traegt eine Lampe mit sich,
         fuer die er keinen Anspruch mehr hat, und niemand sieht warum. Der
         andere Fehlerzweig dieser Funktion meldet sich; dieser tat es nicht. */
      console.warn('[cart] zugabe: window.MQ_ZUGABE fehlt oder ist unvollstaendig,'
        + ' siehe snippets/zugabe-daten.liquid');
      fertig(null, false);
      return;
    }

    fetch(WURZEL + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(jsonLesen)
      .then(function (korb) {
        var ausloeser = false;
        var zugaben = [];
        (korb.items || []).forEach(function (i) {
          if (i.product_id === Z.ausloeser) { ausloeser = true; }
          if (i.properties && i.properties._zugabe) { zugaben.push(i); }
        });

        var stimmt = zugaben.length === 1 && zugaben[0].quantity === 1;
        if (ausloeser && stimmt) { return null; }
        if (!ausloeser && zugaben.length === 0) { return null; }

        var weg = {};
        zugaben.forEach(function (i) { weg[i.key] = 0; });
        var raeumen = zugaben.length
          ? korbSchicken('cart/update.js', { updates: weg })
          : Promise.resolve(null);

        if (!ausloeser) { return raeumen; }
        return raeumen.then(function () {
          return korbSchicken('cart/add.js', {
            items: [{ id: Z.variante, quantity: 1, properties: { _zugabe: '1' } }]
          });
        });
      })
      /* Der zweite Wert sagt, ob wirklich etwas geschickt wurde. Ohne ihn kann
         der Aufrufer "nichts zu tun" nicht von "getan, aber ohne Abschnitte"
         unterscheiden — und muesste beim Seitenstart entweder jedes Mal neu
         laden oder eine echte Aenderung uebersehen. d ist null, wenn der Korb
         bereits stimmte. */
      .then(function (d) { fertig(d && d.sections ? d.sections : null, !!d); })
      .catch(function (err) {
        /* Ein Fehlschlag darf den Kauf nicht aufhalten: Der Kunde hat sein
           Geraet im Korb, nur das Geschenk fehlt. Beim naechsten Seitenaufruf
           greift der Aufruf beim Start und holt es nach. */
        console.warn('[cart] zugabe failed:', err);
        fertig(null, false);
      });
  }

  /* Ein Weg, den Warenkorb neu zu zeichnen — 17.09.2026.

     Die drei Aufrufer von zugabeSichern() hatten denselben Block, zweimal
     woertlich gleich und einmal anders: Beim Seitenstart fehlte der Rueckfall
     auf refresh(). Brachte der Aufruf dort keine Abschnitte zurueck, obwohl er
     den Korb veraendert hatte, blieb die alte Darstellung stehen — ein Korb
     ohne die gerade eingelegte Lampe oder mit einer gerade entfernten.

     `ersatz` sind die Abschnitte der ausloesenden Anfrage, falls es eine gab. */
  function neuZeichnen(abschnitte, ersatz) {
    if (abschnitte) { updateInner(abschnitte); return Promise.resolve(); }
    if (ersatz) { updateInner(ersatz); return Promise.resolve(); }
    /* Gibt die Zusage von refresh() weiter, damit nachEntfernen() erst nach
       dem Neuaufbau den Fokus setzt — 26.09.2026. */
    return refresh();
  }

  /* Nach dem Entfernen einer Zeile — 26.09.2026 (WCAG 2.4.3 und 4.1.3).

     updateInner() ersetzt den ganzen Warenkorb-Koerper; der gedrueckte
     Muelleimer ist danach weg, und der Fokus fiel auf <body>. Jetzt geht er
     auf den Muelleimer, der an derselben Stelle steht (sonst auf den letzten),
     und ist keine Zeile mehr da, im Schieber auf dessen Titel, auf der
     Cart-Seite auf "Continue shopping".

     preventScroll: Das Ziel steht dort, wo die entfernte Zeile stand — die
     Seite soll dabei nicht springen.

     Die Ansage liest der neue Koerper selbst mit (data-ansage in
     snippets/cart-contents.liquid, von Shopify je Sprache gezaehlt). Es gibt
     zwei Statuszeilen in layout/theme.liquid: eine IM Schieber (ausserhalb
     des Koerpers, der ersetzt wird) — ein Dialog mit aria-modal blendet fuer
     Vorleseprogramme alles ausserhalb aus — und eine ausserhalb von
     #scroll-stage fuer die Cart-Seite; #scroll-stage wird inert, sobald eine
     Blende offen ist. Erst leeren, dann fuellen, damit derselbe Satz ein
     zweites Mal angesagt wird.

     hatteFokus: siehe Muelleimer-Zuhoerer — ohne Fokus am Knopf kein
     Fokuswechsel. */
  function nachEntfernen(imSchieber, stelle, hatteFokus) {
    var flaeche = imSchieber ? drawer : document.querySelector('[data-cart-section]');
    if (!flaeche) return;
    var koerper = flaeche.querySelector('.cd__inner');
    var ansage = document.querySelector('[data-cd-ansage="' + (imSchieber ? 'schieber' : 'seite') + '"]');
    if (ansage && koerper) {
      ansage.textContent = '';
      var satz = koerper.getAttribute('data-ansage') || '';
      window.setTimeout(function () { ansage.textContent = satz; }, 100);
    }
    if (!hatteFokus) return;
    var eimer = flaeche.querySelectorAll('[data-cd-remove]');
    var ziel = eimer.length
      ? eimer[Math.min(stelle, eimer.length - 1)]
      : flaeche.querySelector(imSchieber ? '.mq-ov__title' : '[data-cart-when-empty]');
    if (ziel) { ziel.focus({ preventScroll: true }); }
  }

  function addToCart(form) {
    var freigeben = knoepfeSperren();
    kauffehler('');

    // Bis zum 04.08.2026 gingen hier ZWEI Positionen raus: das Geraet und der
    // Schutzplan als eigener Artikel. Das war falsch. Am selben Tag gemessen:
    // Wer das Geraet aus dem Warenkorb loeschte, behielt den Plan; wer die
    // Menge aenderte, bekam den Plan nicht mit; im Checkout standen zwei
    // Zeilen statt einer.
    //
    // Der Schutz ist jetzt eine Produktoption. Jede Kombination aus Bundle-
    // Groesse und Laufzeit ist eine eigene Variante und ein festes Shopify-
    // Bundle — Geraet, Gratis-Zugabe und Plan sind ihre Bestandteile. Es geht
    // also wieder genau eine Position raus, und das Formular allein reicht.
    var fd = new FormData(form);
    fd.append('sections', sektionsListe());
    fd.append('sections_url', window.location.pathname);

    fetch(WURZEL + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        /* Kein englischer Ersatzsatz mehr: Ohne eigenen Grund von Shopify wird
           NICHTS geworfen, was wie ein Text aussieht — dann greift unten der
           uebersetzte Rueckfall aus data-fallback. Bis zum 15.08.2026 stand hier
           'Could not add to cart', und weil der catch-Zweig jede Zeichenkette
           uebernimmt, erschien dieser englische Satz auch im spanischen Shop. */
        if (!res.ok) { throw (res.d && res.d.description) || new Error('add failed'); }
        /* Die Zugabe wird NACH dem Geraet geholt, nicht in derselben Anfrage:
           Ein zweiter Artikel im selben Aufruf wuerde bei jedem Kauf eine
           weitere Lampe addieren. zugabeSichern() liest stattdessen den Korb
           und stellt her, was gelten soll. Gezeichnet wird einmal — mit den
           Abschnitten, die sie zurueckbringt, sonst mit denen des Kaufs.

           26.09.2026: Der Knopf wird erst frei, wenn der Abgleich FERTIG ist.
           Bis heute gab dieser Schritt nichts zurueck, weil zugabeSichern()
           mit einem Rueckruf arbeitet. Das .then(freigeben) unten lief deshalb
           sofort nach der Kauf-Antwort: Der Knopf zeigte wieder "Add to cart",
           waehrend noch bis zu drei Anfragen liefen (cart.js, update.js,
           add.js) und der Schieber zu war. Ein ungeduldiger zweiter Klick legte
           ein zweites Geraet ein. Jetzt wartet die Kette auf den Rueckruf.

           Der Notausgang nach 8 Sekunden sorgt dafuer, dass ein haengendes Netz
           den Kaufknopf nicht fuer immer sperrt. Der Abgleich selbst laeuft
           dann trotzdem zu Ende und zeichnet den Warenkorb neu. */
        return new Promise(function (weiter) {
          var erledigt = false;
          var notGegriffen = false;
          function einmal() { if (!erledigt) { erledigt = true; weiter(); } }
          /* Greift der Notausgang, ist der Kauf laengst angekommen, nur der
             Abgleich haengt. Also erst ZEIGEN, dass es geklappt hat, dann den
             Knopf freigeben — sonst haelt der Kunde den Kauf fuer gescheitert
             und klickt noch einmal. */
          var notausgang = window.setTimeout(function () {
            notGegriffen = true;
            try {
              neuZeichnen(null, res.d.sections);
              openDrawer();
            } finally {
              einmal();
            }
          }, 8000);
          zugabeSichern(function (abschnitte) {
            window.clearTimeout(notausgang);
            try {
              neuZeichnen(abschnitte, res.d.sections);
              /* Kam der Abgleich erst nach dem Notausgang, ist der Schieber
                 schon offen gewesen; der Kunde hat ihn vielleicht inzwischen
                 geschlossen. Dann nur neu zeichnen, nicht ungefragt wieder
                 aufspringen lassen. */
              if (!notGegriffen) openDrawer();
            } finally {
              einmal();
            }
          });
        });
      })
      .catch(function (err) {
        /* Shopify liefert in description den echten Grund, etwa dass nur noch
           zwei Stueck auf Lager sind. Dieser Text ist bereits uebersetzt und
           genauer als jeder eigene. Nur wenn keiner ankommt — Netzwerkabbruch,
           kaputte Antwort — greift der Satz aus der Sprachdatei. */
        var box = document.querySelector('[data-pb-adderr]');
        var ersatz = box ? box.getAttribute('data-fallback') : '';
        kauffehler(typeof err === 'string' && err ? err : ersatz);
        console.warn('[cart] add failed:', err);
      })
      .then(freigeben);
  }

  /*
    The bundle disclosure. The checkout animates the panel's HEIGHT (its
    ._94sxtb1 rule is `transition-property: height, opacity`) — height can only
    animate between two lengths, so open goes 0 → measured px → auto, and close
    goes auto → measured px → 0. Same states the checkout leaves behind:
    height:auto;overflow:visible when open, height:0px;overflow:hidden when shut.
  */
  function toggleDisclosure(btn) {
    var panel = btn.parentElement.querySelector('[data-cd-disclosure-panel]');
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var label = btn.querySelector('[data-cd-disclosure-label]');
    // Das Pfeil-Symbol ist Shopifys eigenes Sprite. Der Checkout tauscht beim
    // Klick nur die Adresse dahinter (chevronDown <-> chevronUp) — gemessen am
    // laufenden Checkout, Vorher/Nachher verglichen.
    var icon = btn.querySelector('svg use');

    var target = open ? 0 : panel.scrollHeight;
    panel.style.overflow = 'hidden';
    panel.style.height = (open ? panel.scrollHeight : 0) + 'px';

    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (label) label.textContent = label.getAttribute(open ? 'data-show' : 'data-hide');
    if (icon) {
      icon.setAttribute(
        'href',
        icon.getAttribute('href').replace(open ? 'chevronUp' : 'chevronDown', open ? 'chevronDown' : 'chevronUp')
      );
    }

    // Two frames: the first commits the start height, the second starts the
    // transition. Doing both in one task made the browser skip the animation
    // and leave the panel rendered at 0 while its style said the new height.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { panel.style.height = target + 'px'; });
    });

    // Settle on auto so the panel keeps growing if its content ever changes.
    // On a timer, not on transitionend: with reduced motion the duration is 1ms
    // and the event can be missed entirely.
    var ms = (parseFloat(getComputedStyle(panel).transitionDuration) || 0) * 1000;
    clearTimeout(panel.__cdT);
    panel.__cdT = setTimeout(function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        panel.style.height = 'auto';
        panel.style.overflow = 'visible';
      }
    }, ms + 80);
  }

  /*
    Notweg, wenn die Antwort keine Abschnitte mitbrachte. Holt jede Flaeche
    einzeln, damit auch hier niemand die Fassung der anderen bekommt.
  */
  /* Gibt eine Zusage zurueck. Wer danach am neu aufgebauten Warenkorb etwas
     setzen will, muss warten koennen — sonst ersetzt der Neuaufbau es gleich
     wieder. Genau das passierte der Ablaufmeldung der Reservierungsuhr
     (am 26.09.2026 entfernt). */
  function refresh() {
    var teile = sektionsListe().split(',');
    /* Jeder Abschnitt einzeln abgesichert (26.09.2026): Scheitert einer,
       zeichnet updateInner() mit dem anderen — wie vor der Statuspruefung, als
       die Fehlerseite einfach keinen Warenkorb-Koerper enthielt. */
    return Promise.all(teile.map(function (id) {
      return fetch(WURZEL + '?section_id=' + id).then(textLesen)
        .catch(function (err) { console.warn('[cart] refresh ' + id + ' failed:', err); return null; });
    })).then(function (texte) {
      var sections = {};
      teile.forEach(function (id, i) { if (texte[i] != null) { sections[id] = texte[i]; } });
      updateInner(sections);
    })
      /* Ohne diesen Zweig brach die Zusage bei einem einzigen fehlgeschlagenen
         Abschnitt still ab: Warenkorb-Zaehler und Liste blieben auf dem alten
         Stand, ohne Spur. Dieser Notweg laeuft immer dann, wenn eine Antwort
         keine sections mitbringt — also genau dann, wenn ohnehin schon etwas
         nicht nach Plan lief. */
      .catch(function (err) { console.warn('[cart] refresh failed:', err); });
  }
})();

/* ============================================================================
   Sprungnavigation "Auf dieser Seite"          (sections/rechts-inhalt.liquid)
   Ergaenzt am 02.08.2026.

   Baut die Liste aus den Ueberschriften, die links wirklich stehen. Der Text
   einer Rechtsseite kommt als fertiges HTML aus Shopify — Liquid kann darin
   nichts finden, also liest das hier die gerenderte Seite.

   Weniger als zwei Ueberschriften: Der Kasten bleibt versteckt. Eine
   Sprungliste mit einem Eintrag ist keine Navigation.
   ========================================================================= */
(function () {
  var kasten = document.querySelector('[data-inhalt]');
  var liste = document.querySelector('[data-inhalt-liste]');
  if (!kasten || !liste) { return; }

  /* Nur der Fliesstext links. Ohne diese Eingrenzung landen die Ueberschriften
     aus Kopfbereich, Fussbereich und der rechten Spalte selbst mit in der
     Liste — sie wuerde auf sich selbst zeigen. */
  /* 02.08.2026 korrigiert. Vorher fiel die Suche auf document.body zurueck,
     weil das Geruest kein <main> hat und .pg__inner auf Rechtsseiten nicht
     existiert. Folge: die Ueberschriften des Warenkorb-Schubfachs, das in
     jeder Seite mitgeliefert wird, landeten in der Sprungliste.

     .shopify-policy__body ist der Textkoerper, den Shopify um jeden
     Rechtstext legt; .rte umschliesst den Inhalt unserer eigenen Seiten. */
  var quelle = document.querySelector('.shopify-policy__body') ||
               document.querySelector('.pg__inner .rte') ||
               document.querySelector('.pg__inner') ||
               document.querySelector('main');
  if (!quelle) { return; }

  var ueber = quelle.querySelectorAll('h2, h3');
  var gefunden = [];

  for (var i = 0; i < ueber.length; i++) {
    var h = ueber[i];
    if (kasten.contains(h)) { continue; }
    var text = (h.textContent || '').trim();
    if (!text) { continue; }

    /* Shopifys Rechtstexte kennen nur eine Ueberschriftenebene: Auf
       /policies/refund-policy sind am 02.08.2026 alle elf Ueberschriften h3,
       darunter Zwischenzeilen wie "What it costs you." mitten im Abschnitt.
       Nach Tag laesst sich also nicht trennen.

       Zwei Merkmale unterscheiden einen Abschnittstitel von einer Zwischenzeile
       verlaesslich: Ein Titel ist kein ganzer Satz, endet also nicht auf einen
       Punkt, und er ist kurz. Beides zusammen filtert die Zwischenzeilen heraus,
       ohne einen echten Abschnitt zu verlieren.

       Sauberer waere eine richtige Gliederung im Rechtstext selbst — h2 fuer
       Abschnitte, h3 fuer Zwischenzeilen. Das ist eine Aenderung an bindendem
       Text und braucht eine ausdrueckliche Freigabe. */
    if (/[.!?]$/.test(text)) { continue; }
    if (text.length > 60) { continue; }

    /* Ohne id kann man nicht hinspringen. Shopifys Rechtstexte bringen keine
       mit, also vergeben wir eine — stabil aus der Position, damit ein Anker
       im Verlauf nicht bei jedem Aufruf auf etwas anderes zeigt. */
    if (!h.id) { h.id = 'a' + (i + 1); }

    gefunden.push({ id: h.id, text: text, tief: h.tagName === 'H3' });
  }

  if (gefunden.length < 2) { return; }

  var html = '';
  for (var j = 0; j < gefunden.length; j++) {
    var e = gefunden[j];
    html += '<li class="ri__punkt' + (e.tief ? ' ri__punkt--tief' : '') + '">' +
      '<a class="ri__link" href="#' + e.id + '">' +
      e.text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') +
      '</a></li>';
  }

  liste.innerHTML = html;
  kasten.hidden = false;

  /* Der aktuell gelesene Abschnitt wird hervorgehoben. IntersectionObserver
     statt scroll-Handler: Der Browser rechnet selbst und ruft nur, wenn sich
     wirklich etwas aendert — kein Ruckeln beim Scrollen.

     Fehlt die Schnittstelle (sehr alte Browser), bleibt die Liste ohne
     Hervorhebung nutzbar. */
  if (!('IntersectionObserver' in window)) { return; }

  var links = {};
  var alle = liste.querySelectorAll('.ri__link');
  for (var k = 0; k < alle.length; k++) {
    links[alle[k].getAttribute('href').slice(1)] = alle[k];
  }

  var beobachter = new IntersectionObserver(function (eintraege) {
    for (var m = 0; m < eintraege.length; m++) {
      var a = links[eintraege[m].target.id];
      if (!a) { continue; }
      if (eintraege[m].isIntersecting) {
        for (var n = 0; n < alle.length; n++) { alle[n].classList.remove('is-hier'); }
        a.classList.add('is-hier');
      }
    }
  }, {
    /* Der Auslesestreifen liegt im oberen Fuenftel des Fensters: dort steht
       die Ueberschrift, die man gerade liest.

       02.08.2026 von -75% auf -80% mit 80px Vorlauf oben geaendert. Mit dem
       alten Wert wurden die letzten Abschnitte nie markiert: wer ganz nach
       unten scrollt, bekommt sie nicht mehr in den oberen Streifen, weil
       darunter kein Weg mehr ist. Der Vorlauf faengt zusaetzlich den Fall ab,
       dass eine Ueberschrift knapp ueber der Oberkante steht. */
    rootMargin: '80px 0px -80% 0px'
  });

  for (var p = 0; p < gefunden.length; p++) {
    var ziel = document.getElementById(gefunden[p].id);
    if (ziel) { beobachter.observe(ziel); }
  }
})();
